<template>
  <div>
    <div class="header">
      <div class="container-fluid">

        <!-- =============================== -->
        <!-- SELECT EMPRESA + ARCHIVO -->
        <!-- =============================== -->

        <b-row v-if="empresasCliente.length" class="align-items-center mt-3">

          <!-- SELECT EMPRESA -->
          <b-col md="2">
            <template v-if="showEmpresaBadge">
              <span class="small text-muted mr-2">{{ $t('empresa') }}:</span>
              <span class="badge badge-primary px-3 text-uppercase" style="display:inline-flex;align-items:center;height:32px;font-size:.85rem;">{{ nombreEmpresaSeleccionada || '—' }}</span>
            </template>
            <template v-else>
              <el-select v-model="empresaSeleccionada" :placeholder="$t('placeholder_empresa')" style="width: 100%;"
                @change="onEmpresaSeleccionada" filterable>
                <el-option v-for="e in empresasCliente" :key="e.id" :value="e.id" :label="e.nombre" />
              </el-select>
            </template>
          </b-col>

          <!-- BUSCADOR POR NRO DE FICHA -->
          <b-col md="3">
            <b-input-group>
              <b-form-input v-model="buscarFichaTexto" type="number" min="1"
                :placeholder="$t('buscar_por_ficha_placeholder')" @keyup.enter="buscarPorNroFicha" />
              <b-input-group-append>
                <b-button variant="primary" :disabled="buscandoFicha" @click="buscarPorNroFicha">
                  <i class="fas fa-spinner fa-spin" v-if="buscandoFicha"></i>
                  <i class="fas fa-search" v-else></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <!-- CONTADOR DE CLUSTERS + VOLVER (cuando hay archivo seleccionado) -->
          <b-col v-if="archivoSeleccionado" class="d-flex align-items-center" style="gap:10px;">
            <span class="clusters-count-badge">
              <strong>{{ resumenClusters.length }}</strong> {{ $t('clusters_label') }}
            </span>
            <b-button size="sm" variant="secondary" @click="volverATabla">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('volver') || 'Volver' }}
            </b-button>
          </b-col>

          <!-- BUSCADOR GLOBAL (solo visible con archivo seleccionado) -->
          <b-col md="4" v-if="archivoSeleccionado">
            <b-input-group>
              <b-form-input v-model="textoBusqueda"
                :placeholder="$t('buscar_global_placeholder')" @keyup.enter="buscarGlobal" />
              <b-input-group-append>
                <b-button variant="primary" @click="buscarGlobal">{{ $t('buscar') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

        </b-row>

        <!-- Tabla Upload Files -->
        <div v-if="empresaSeleccionada && archivosLogs.length && !archivoSeleccionado" class="my-2">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <h5 class="text-primary mb-0">{{ $t('archivos_cargados') }}</h5>
            <b-button size="sm" variant="primary" @click="onEmpresaSeleccionada">
              <i class="fas fa-sync-alt mr-1"></i> {{ $t('refrescar') }}
            </b-button>
          </div>
          <table class="table table-bordered table-hover table-sm tabla-archivos-cargados">
            <thead class="thead-light">
              <tr>
                <th style="width:40px;">#</th>
                <th class="th-ordenable" @click="ordenarPorArchivos('nombreXLSX')">
                  <input class="th-search-input" v-model="filterColArchivos.nombreXLSX" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('nombre_archivo') }} <i :class="iconoOrdenArchivos('nombreXLSX')"></i></span>
                </th>
                <th class="th-ordenable text-center" @click="ordenarPorArchivos('estadoFlujoDesc')">
                  <input class="th-search-input" v-model="filterColArchivos.estadoFlujoDesc" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('estado') }} <i :class="iconoOrdenArchivos('estadoFlujoDesc')"></i></span>
                </th>
                <th class="th-ordenable text-right" @click="ordenarPorArchivos('fechaRentabilizacion')">
                  <input class="th-search-input" v-model="filterColArchivos.fechaRentabilizacion" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('fecha_rentabilizacion') }} (GMT 0) <i :class="iconoOrdenArchivos('fechaRentabilizacion')"></i></span>
                </th>
                <th class="th-ordenable text-right" @click="ordenarPorArchivos('fechaClusterizacion')">
                  <input class="th-search-input" v-model="filterColArchivos.fechaClusterizacion" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('fecha_clusterizacion') }} (GMT 0) <i :class="iconoOrdenArchivos('fechaClusterizacion')"></i></span>
                </th>
                <th class="th-ordenable text-center" @click="ordenarPorArchivos('tipoFlujo')">
                  <input class="th-search-input" v-model="filterColArchivos.tipoFlujo" @click.stop :placeholder="$t('buscar')" />
                  <span class="th-label">{{ $t('tipo_flujo') }} <i :class="iconoOrdenArchivos('tipoFlujo')"></i></span>
                </th>
                <th>{{ $t('accion') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(archivo, index) in processedArchivosLogs" :key="archivo.token">
                <td>{{ index + 1 }}</td>
                <td>{{ archivo.nombreXLSX }}</td>
                <td class="text-center align-middle">
                  <span v-if="['K','J','L'].includes((archivo.estadoFlujo || '').toUpperCase())" class="badge badge-danger">{{ archivo.estadoFlujoDesc || $t('error') || 'Error' }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'P'" class="badge badge-danger">{{ archivo.estadoFlujoDesc || $t('sin_rentabilizacion') }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'S'" class="badge badge-warning">{{ archivo.estadoFlujoDesc || $t('en_proceso') }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'R'" class="badge badge-success">{{ archivo.estadoFlujoDesc || $t('rentabilizado') }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'C'" class="badge badge-info">{{ archivo.estadoFlujoDesc || $t('clusterizando') }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'T'" class="badge badge-primary">{{ archivo.estadoFlujoDesc || $t('clusterizado') || 'Clusterizado' }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'I'" class="badge badge-warning">{{ archivo.estadoFlujoDesc || $t('esperando_procesar') || 'Esperando procesar' }}</span>
                  <span v-else-if="(archivo.estadoFlujo || '').toUpperCase() === 'E'" class="badge badge-ecommerce">{{ archivo.estadoFlujoDesc || $t('ecommerce') || 'E-Commerce' }}</span>
                  <span v-else class="badge badge-dark">{{ archivo.estadoFlujoDesc || $t('desconocido') }}</span>
                </td>
                <td class="text-right">{{ formatFechaGmt0(archivo.fechaRentabilizacion) }}</td>
                <td class="text-right">{{ formatFechaGmt0(archivo.fechaClusterizacion) }}</td>
                <td class="text-center align-middle">
                  <span v-if="(archivo.tipoFlujo || '').trim() === 'FN'" class="badge badge-primary">{{ $t('tipo_flujo_fn') }}</span>
                  <span v-else-if="(archivo.tipoFlujo || '').trim() === 'NR'" class="badge badge-warning">{{ $t('tipo_flujo_nr') }}</span>
                  <span v-else-if="(archivo.tipoFlujo || '').trim() === 'DE'" class="badge badge-info">{{ $t('tipo_flujo_de') }}</span>
                  <span v-else class="text-muted">—</span>
                </td>
                <td>
                  <b-button v-if="(archivo.estadoFlujo || '').toUpperCase() === 'E'"
                    size="sm" class="btn-green mr-1" variant="info"
                    @click="seleccionarArchivoDesdeTabla(archivo)">
                    {{ $t('ver_detalle') }}
                  </b-button>
                  <b-button v-if="puedeEscribir && ((archivo.estadoFlujo || '').toUpperCase() === 'E')"
                    size="sm" variant="warning"
                    @click="confirmarVolverAdmInventario(archivo)">
                    {{ $t('volver_adm_inventario') || 'Volver Adm. Inventario' }}
                  </b-button>
                  <span v-if="!['E'].includes((archivo.estadoFlujo || '').toUpperCase())" class="text-muted small">—</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mensaje sin archivos -->
        <div v-if="empresaSeleccionada && archivosConsultados && !archivosLogs.length && !archivoSeleccionado"
          class="my-4 text-center text-muted">
          <i class="fas fa-folder-open fa-2x mb-2 d-block"></i>
          {{ $t('sin_archivos_empresa') || 'Esta empresa no tiene archivos cargados.' }}
        </div>

        <!-- =============================== -->
        <!-- RESULTADOS BUSQUEDA -->
        <!-- =============================== -->
        <div v-if="resultadosBusqueda.length" class="mt-3">

          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">{{ $t('resultados') }} ({{ resultadosFiltrados.length }} {{ $t('de') }} {{ resultadosBusqueda.length }})</h5>
            <b-button variant="success" size="sm" @click="exportarExcelResultados" :title="$t('exportar_archivo') || 'Exportar a Excel'">
              <i class="fas fa-file-excel"></i>
            </b-button>
          </div>

          <div class="table-responsive-custom tabla-clusters-scroll" ref="tablaResultados">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('cliente')">{{ $t('cliente') }} {{ obtenerIconoOrdenResultados('cliente') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.cliente" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('archivo')">{{ $t('archivo') }} {{ obtenerIconoOrdenResultados('archivo') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.archivo" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('cluster')">Cluster {{ obtenerIconoOrdenResultados('cluster') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.cluster" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('detalleId')">ID {{ obtenerIconoOrdenResultados('detalleId') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.detalleId" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('familia')">{{ $t('familia') }} {{ obtenerIconoOrdenResultados('familia') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.familia" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('fabricante')">{{ $t('fabricante') }} {{ obtenerIconoOrdenResultados('fabricante') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.fabricante" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('brandName')">{{ $t('marca') }} {{ obtenerIconoOrdenResultados('brandName') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.brandName" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('partNumber')">{{ $t('part_number') }} {{ obtenerIconoOrdenResultados('partNumber') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.partNumber" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('partName')">{{ $t('part_name') }} {{ obtenerIconoOrdenResultados('partName') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.partName" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('modelo')">{{ $t('modelo') }} {{ obtenerIconoOrdenResultados('modelo') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.modelo" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('condicion')">{{ $t('condicion') }} {{ obtenerIconoOrdenResultados('condicion') }}</div>
                    <select class="th-search-input" v-model="filtrosBusqueda.condicion">
                      <option v-for="op in opcionesCondicionBusqueda" :key="op.value" :value="op.value">{{ op.text }}</option>
                    </select>
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('detalles')">{{ $t('detalles') }} {{ obtenerIconoOrdenResultados('detalles') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.detalles" :placeholder="$t('buscar')" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('cantidad')">{{ $t('cantidad_inicial') }} {{ obtenerIconoOrdenResultados('cantidad') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.cantidad" placeholder="" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('valorSugerido')">{{ $t('valor_unitario_sugerido_usd') }} {{ obtenerIconoOrdenResultados('valorSugerido') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.valorSugerido" placeholder="" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('valorTotalSugerido')">{{ $t('valor_total_sugerido_usd') }} {{ obtenerIconoOrdenResultados('valorTotalSugerido') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.valorTotalSugerido" placeholder="" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPorResultados('cantidadDisponible')">{{ $t('cantidad_disponible') }} {{ obtenerIconoOrdenResultados('cantidadDisponible') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosBusqueda.cantidadDisponible" placeholder="" />
                  </th>
                  <th>{{ $t('multimedia') }}</th>
                  <th>
                    {{ $t('publicacion') }}
                    <select class="th-search-input" v-model="filtrosBusqueda.publicacion">
                      <option v-for="op in opcionesPublicacion" :key="op.value" :value="op.value">{{ op.text }}</option>
                    </select>
                  </th>
                  <th>{{ $t('acciones') }}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(r, i) in resultadosPaginados" :key="i">
                  <td>{{ r.cliente }}</td>
                  <td>{{ r.archivo }}</td>
                  <td>{{ r.cluster }}</td>
                  <td>{{ r.detalleId }}</td>
                  <td>{{ r.familia }}</td>
                  <td>{{ r.fabricante }}</td>
                  <td>{{ r.brandName }}</td>
                  <td>{{ r.partNumber }}</td>
                  <td>{{ r.partName }}</td>
                  <td>{{ r.modelo }}</td>
                  <td>{{ r.condicion }}</td>
                  <td>{{ r.detalles }}</td>
                  <td>{{ number(r.cantidad) }}</td>
                  <td>{{ number(r.valorSugerido) }}</td>
                  <td>{{ number(r.valorTotalSugerido) }}</td>
                  <td>{{ number(r.cantidadDisponible) }}</td>
                  <td class="text-center">
                    <div class="multimedia-badges">
                      <span v-if="r.cantidadFotos > 0" class="badge badge-success mr-1">
                        📷 {{ r.cantidadFotos }}
                      </span>
                      <span v-if="r.cantidadVideos > 0" class="badge badge-danger">
                        🎬 {{ r.cantidadVideos }}
                      </span>
                      <span v-if="!r.cantidadFotos && !r.cantidadVideos" class="text-muted">
                        {{ $t('sin_multimedia') }}
                      </span>
                    </div>
                  </td>

                  <td>
                    <b-button size="sm" variant="info" class="btn-compact-row" @click="abrirModalFotos(r)">{{ $t('multimedia') }}</b-button>
                    <b-button size="sm" variant="warning" class="ml-1 btn-compact-row" @click="abrirModalTerminos(r)">T&C</b-button>
                  </td>
                  <td class="text-center">
                    <div class="d-flex align-items-center justify-content-center flex-nowrap" style="gap: 3px; white-space: nowrap;"
                         v-if="r.idFicha && r.idFicha > 0">
                      <b-button v-if="puedeEscribir"
                        size="sm"
                        variant="success"
                        :disabled="r.estadoPublicacion === 'S' || r.estadoPublicacion === 'D'"
                        :title="$t('pub_publicar')"
                        style="white-space: nowrap; padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                        @click="solicitarPublicacion(r)"
                      >
                        ☁️↑
                      </b-button>
                      <b-button v-if="puedeEscribir"
                        size="sm"
                        variant="danger"
                        :disabled="r.estadoPublicacion !== 'P'"
                        :title="$t('pub_despublicar')"
                        style="white-space: nowrap; padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                        @click="solicitarDespublicacion(r)"
                      >
                        ☁️↓
                      </b-button>
                      <b-badge :variant="getPublicacionVariant(r.estadoPublicacion)" style="font-size: 0.62rem; white-space: nowrap;">
                        {{ getPublicacionLabel(r.estadoPublicacion) }}
                      </b-badge>
                      <b-button
                        v-if="r.mongoSlug && r.estadoPublicacion === 'P'"
                        size="sm"
                        variant="info"
                        style="padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                        @click="abrirEnPortal(r)"
                      >
                        🌐
                      </b-button>
                    </div>
                    <span v-else class="text-muted">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>


        <!-- =============================== -->
        <!-- RESUMEN DE CLUSTERS -->
        <!-- =============================== -->
        <div v-if="resumenClusters.length && !modoBusquedaGlobal" class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">
              {{ $t('resumen_clusters') }}
              (<template v-if="resumenClustersFiltrados.length !== resumenClusters.length">{{ resumenClustersFiltrados.length }} {{ $t('de') }} </template>{{ resumenClusters.length }})
            </h5>
            <div class="d-flex align-items-center" style="gap:10px">
              <span style="font-size:0.8rem; color:#6b7280;">
                <i class="fas fa-sync-alt mr-1" style="color:#9ca3af"></i>
                {{ $t('ultima_sincronizacion') }}: <strong>{{ ultimaSincronizacionPortalTexto }}</strong>
              </span>
              <b-button variant="primary" size="sm" @click="cargarClustersResumen(); cargarUltimaSincronizacionPortal()">
                {{ $t('refrescar') }}
              </b-button>
              <b-button variant="success" size="sm" @click="exportarExcelClusters" :title="$t('exportar_archivo') || 'Exportar a Excel'">
                <i class="fas fa-file-excel"></i>
              </b-button>
            </div>
          </div>

          <div class="table-responsive-custom tabla-clusters-scroll" ref="tablaResumen">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>N°</th>
                  <th class="th-ordenable" style="width:70px; max-width:70px;">
                    <div @click="ordenarPor('id')">ID {{ obtenerIconoOrden('id') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosResumen.id" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPor('nombreCluster')">{{ $t('nombre_cluster') }} {{ obtenerIconoOrden('nombreCluster') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosResumen.nombreCluster" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPor('criterio')">{{ $t('tipo_cluster') }} {{ obtenerIconoOrden('criterio') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosResumen.criterio" />
                  </th>
                  <th class="th-ordenable">
                    <div @click="ordenarPor('fechaCreacion')">{{ $t('fecha_carga') }} {{ obtenerIconoOrden('fechaCreacion') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosResumen.fechaCreacion" />
                  </th>
                  <th class="th-ordenable" style="width:80px; max-width:80px;">
                    <div @click="ordenarPor('cantidadItems')">{{ $t('items_label') }} {{ obtenerIconoOrden('cantidadItems') }}</div>
                    <input type="text" class="th-search-input" v-model="filtrosResumen.cantidadItems" placeholder="" />
                  </th>
                  <th>
                    {{ $t('multimedia') }}
                    <label class="th-checkbox-label">
                      <input type="checkbox" v-model="filtrosResumen.conMultimedia" /> {{ $t('con_multimedia') }}
                    </label>
                  </th>
                  <th>
                    {{ $t('ingreso_ficha') }}
                    <label class="th-checkbox-label">
                      <input type="checkbox" v-model="filtrosResumen.conFicha" /> {{ $t('con_ficha') }}
                    </label>
                  </th>
                  <th>
                    {{ $t('publicacion') }}
                    <select class="th-search-input" v-model="filtrosResumen.publicacion">
                      <option v-for="op in opcionesPublicacion" :key="op.value" :value="op.value">{{ op.text }}</option>
                    </select>
                  </th>
                  <th style="min-width:180px;">{{ $t('categoria') }}</th>
                  <th style="min-width:160px;">{{ $t('fabricante') }}</th>
                  <th style="min-width:160px;">{{ $t('modelo') }}</th>
                  <th style="min-width:180px;">{{ $t('condicion') }}</th>
                  <th style="width:70px;" class="text-center">{{ $t('guardar') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, index) in resumenClustersPaginado" :key="c.id" @click="verDetalleCluster(c)"
                  :data-cluster-id="c.id"
                  :class="{ 'row-destacada': c.id === clusterDestacadoId, 'fila-modificada': c._dirty }"
                  style="cursor: pointer;">
                  <td>{{ (paginaResumen - 1) * pageSizeResumen + index + 1 }}</td>
                  <td>#{{ c.id }}</td>
                  <td>
                    {{ nombreClusterParaMostrar(c.nombreCustom || c.NombreCustom || c.nombreCluster) }}
                    <button v-if="['8', '9', '10'].includes(String(c.idCriterio))"
                            class="btn btn-sm btn-link p-0 ml-1" style="vertical-align:baseline;"
                            @click.stop="editarNombreCustomCluster(c)" :title="$t('editar')">
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                  </td>
                  <td>{{ c.criterio }}</td>
                  <td class="text-center">{{ formatDate(c.fechaCreacion) }}</td>
                  <td class="text-center">{{ c.cantidadItems }}</td>
                  <td @click.stop>
                    <div class="multimedia-badges">
                      <span v-if="c.cantidadFotos > 0" class="badge badge-success mr-1">
                        📷 {{ c.cantidadFotos }}
                      </span>
                      <span v-if="c.cantidadVideos > 0" class="badge badge-danger mr-1">
                        🎬 {{ c.cantidadVideos }}
                      </span>
                      <span v-if="!c.cantidadFotos && !c.cantidadVideos" class="text-muted small">
                        {{ $t('sin_multimedia') }}
                      </span>
                    </div>
                    <b-button size="sm" variant="info" class="ml-2 btn-compact-row"
                      @click="abrirModalFotosCluster(c)">{{ $t('multimedia') }}</b-button>
                  </td>
                  <td @click.stop>
                    <b-button :variant="c.idFicha && c.idFicha > 0 ? 'primary' : 'secondary'" size="sm" class="btn-compact-row"
                      @click="abrirModalFichaConId(c)">
                      {{ c.idFicha && c.idFicha > 0 ? $t('ver_ficha') + ' #' + c.idFicha : $t('sin_ficha') }}
                    </b-button>
                  </td>
                  <td @click.stop class="text-center">
                    <div class="d-flex align-items-center justify-content-center flex-nowrap" style="gap: 3px; white-space: nowrap;"
                         v-if="c.idFicha && c.idFicha > 0">
                      <b-button v-if="puedeEscribir"
                        size="sm"
                        variant="success"
                        :disabled="c.estadoPublicacion === 'S' || c.estadoPublicacion === 'D'"
                        :title="$t('pub_publicar')"
                        style="white-space: nowrap; padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                        @click="solicitarPublicacion(c)"
                      >
                        ☁️↑
                      </b-button>
                      <b-button v-if="puedeEscribir"
                        size="sm"
                        variant="danger"
                        :disabled="c.estadoPublicacion !== 'P'"
                        :title="$t('pub_despublicar')"
                        style="white-space: nowrap; padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                        @click="solicitarDespublicacion(c)"
                      >
                        ☁️↓
                      </b-button>
                      <b-badge :variant="getPublicacionVariant(c.estadoPublicacion)" style="font-size: 0.62rem; white-space: nowrap;">
                        {{ getPublicacionLabel(c.estadoPublicacion) }}
                      </b-badge>
                      <b-button
                        v-if="c.mongoSlug && c.estadoPublicacion === 'P'"
                        size="sm"
                        variant="info"
                        style="padding: 0.15rem 0.35rem; font-size: 0.7rem; line-height: 1;"
                        @click="abrirEnPortal(c)"
                      >
                        🌐
                      </b-button>
                    </div>
                    <span v-else class="text-muted">—</span>
                  </td>
                  <td @click.stop style="min-width:180px;">
                    <el-select v-model="c.categoria" filterable clearable :placeholder="$t('seleccione')"
                      style="width:100%;" :disabled="!puedeEscribir" @change="marcarDirtyResumen(c)">
                      <el-option v-for="op in opcionesCategoriaResumen" :key="op.value" :label="op.label" :value="op.value" />
                    </el-select>
                  </td>
                  <td @click.stop style="min-width:160px;">
                    <input type="text" class="form-control form-control-sm" v-model.trim="c.fabricante"
                      :readonly="!puedeEscribir" @input="marcarDirtyResumen(c)" />
                  </td>
                  <td @click.stop style="min-width:160px;">
                    <input type="text" class="form-control form-control-sm" v-model.trim="c.modelo"
                      :readonly="!puedeEscribir" @input="marcarDirtyResumen(c)" />
                  </td>
                  <td @click.stop style="min-width:180px;">
                    <el-select v-model="c.idCondicion" filterable clearable :placeholder="$t('seleccione')"
                      style="width:100%;" :disabled="!puedeEscribir" @change="marcarDirtyResumen(c)">
                      <el-option v-for="op in opcionesCondicionResumen" :key="op.value" :label="op.label" :value="op.value" />
                    </el-select>
                  </td>
                  <td @click.stop class="text-center">
                    <button v-if="puedeEscribir" class="btn btn-sm btn-success" :class="{ 'btn-pulse': c._dirty && !c._saving }"
                      :disabled="!c._dirty || c._saving" @click="guardarCamposResumen(c)" :title="$t('guardar')">
                      <span v-if="c._saving" class="spinner-border spinner-border-sm"></span>
                      <i v-else class="fas fa-save"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

    <!-- =============================== -->
    <!-- BARRA FLOTANTE DE NAVEGACIÓN -->
    <!-- =============================== -->
    <div v-if="modoBusquedaGlobal" class="pagination-floating-bar">
      <div class="d-flex align-items-center">
        <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
        <select v-model.number="pageSizeResultados" @change="paginaResultados = 1" class="form-control form-control-sm" style="width:70px;">
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
          <option :value="500">500</option>
          <option :value="999999">{{ $t('todos') }}</option>
        </select>
      </div>
      <div class="d-flex align-items-center" style="gap:12px;">
        <button class="btn btn-outline-secondary btn-sm" :disabled="paginaResultados === 1" @click="paginaResultados--">
          <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
        </button>
        <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
          {{ $t('pagina') }} {{ paginaResultados }} {{ $t('de') }} {{ totalPagesResultados }}
          <span class="text-muted ml-2" style="font-size:.8rem;">({{ resultadosFiltrados.length }} {{ $t('resultados') }})</span>
        </span>
        <button class="btn btn-outline-primary btn-sm" :disabled="paginaResultados >= totalPagesResultados" @click="paginaResultados++">
          {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
        </button>
      </div>
      <div class="d-flex align-items-center" style="gap:6px;">
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
      </div>
    </div>

    <div v-else-if="resumenClusters.length" class="pagination-floating-bar">
      <div class="d-flex align-items-center">
        <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
        <select v-model.number="pageSizeResumen" @change="paginaResumen = 1" class="form-control form-control-sm" style="width:70px;">
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
          <option :value="500">500</option>
          <option :value="999999">{{ $t('todos') }}</option>
        </select>
      </div>
      <div class="d-flex align-items-center" style="gap:12px;">
        <button class="btn btn-outline-secondary btn-sm" :disabled="paginaResumen === 1" @click="paginaResumen--">
          <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
        </button>
        <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
          {{ $t('pagina') }} {{ paginaResumen }} {{ $t('de') }} {{ totalPagesResumen }}
          <span class="text-muted ml-2" style="font-size:.8rem;">({{ resumenClustersFiltrados.length }} {{ $t('resultados') }})</span>
        </span>
        <button class="btn btn-outline-primary btn-sm" :disabled="paginaResumen >= totalPagesResumen" @click="paginaResumen++">
          {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
        </button>
      </div>
      <div class="d-flex align-items-center" style="gap:6px;">
        <button class="btn btn-sm btn-scroll-nav" @click="mostrarInfoResumenCluster" :title="$t('informacion')"><i class="fas fa-info-circle"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
        <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
      </div>
    </div>

    <b-modal id="modal-ficha" :title="$t('formulario_venta_titulo')" size="xl" dialog-class="modal-ficha-wide">
      <div class="modal-ficha-content" v-if="archivoSeleccionado && clusterSeleccionado">
        <FichaPanel
          ref="fichaPanel"
          :cluster="clusterSeleccionado"
          :token="archivoSeleccionado.token"
          :idCluster="clusterSeleccionado ? clusterSeleccionado.id : null"
          mostrarMultimedia
          @guardado="onFichaGuardada"
          @abrir-multimedia="abrirModalFotos($event)"
        />
      </div>
      <template #modal-footer>
        <b-button size="sm" variant="secondary" @click="fichaLimpiar">
          <i class="fas fa-eraser mr-1"></i> {{ $t('limpiar') }}
        </b-button>
        <b-button size="sm" variant="info" @click="fichaVerFicha">
          <i class="fas fa-file-pdf mr-1"></i> {{ $t('ficha_venta_pdf') }}
        </b-button>
        <b-button v-if="puedeEscribir" size="sm" variant="success" @click="fichaGuardar">
          <i class="fas fa-save mr-1"></i> {{ $t('guardar') }}
        </b-button>
        <b-button size="sm" variant="light" @click="$bvModal.hide('modal-ficha')">
          <i class="fas fa-times mr-1"></i> {{ $t('cerrar') }}
        </b-button>
      </template>
    </b-modal>

    <!-- =============================== -->
    <!-- MODAL FOTOS Y VIDEOS ITEM (Búsqueda Global) -->
    <!-- =============================== -->
    <b-modal v-model="modalFotos" :title="$t('fotos_videos_item')" size="xl">
      <div>
        <p><strong>ID Item:</strong> {{ fotoActual ? fotoActual.detalleId : "" }}</p>

        <b-tabs content-class="mt-3">
          <!-- TAB FOTOS -->
          <b-tab :title="'📷 ' + $t('fotos')" active>
            <div v-if="fotosActuales.length" class="mb-3">
              <h5>{{ $t('fotos_guardadas') }}</h5>
              <div class="row">
                <div v-for="(f, i) in fotosActuales" :key="i" class="col-4 mb-3 text-center">
                  <img :src="f.url" class="img-fluid bordered rounded" />
                  <div class="mt-2">
                    <b-form-checkbox
                      :disabled="!puedeEscribir"
                      :checked="Boolean(f.esPortada)"
                      @change="marcarFotoPrincipalItem(f)"
                    >
                      Principal
                    </b-form-checkbox>
                  </div>
                  <b-button v-if="puedeEscribir" class="mt-2" variant="danger" size="sm" @click="eliminarFoto(f.id)">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </div>
            </div>
            <div v-else class="text-muted mb-3">{{ $t('no_fotos_guardadas') }}</div>

            <hr />

            <h5>{{ $t('subir_fotos') }}</h5>
            <small class="text-muted d-block mb-2">{{ $t('formatos_imagen_permitidos') }}</small>
            <small
              class="d-block mb-2"
              :class="cupoFotosItem ? 'text-muted' : 'text-danger'"
            >
              {{ cupoFotosItem
                ? $t('max_fotos_ayuda', { max: maxFotos, cupo: cupoFotosItem })
                : $t('max_fotos_alcanzado', { max: maxFotos }) }}
            </small>
            <input
              ref="inputFotosItem"
              type="file"
              multiple
              accept="image/jpeg,image/png,image/webp,image/gif"
              :disabled="!cupoFotosItem"
              @change="onFileSelect"
            />

            <b-button
              v-if="puedeEscribir"
              class="mt-3"
              variant="success"
              :disabled="!archivosSeleccionados.length"
              @click="subirFotos"
            >
              {{ $t('subir_fotos') }}
            </b-button>
          </b-tab>

          <!-- TAB VIDEOS -->
          <b-tab :title="'🎬 ' + $t('videos')">
            <div v-if="videosItemActuales.length" class="mb-4">
              <h5>{{ $t('videos_guardados') }}</h5>
              <div class="row">
                <div v-for="(v, i) in videosItemActuales" :key="i" class="col-6 mb-3">
                  <div class="video-card">
                    <div class="video-preview">
                      <iframe :src="getYoutubeEmbedUrl(v.url)" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen class="video-iframe"></iframe>
                    </div>
                    <div class="video-actions mt-2 text-center">
                      <a :href="v.url" target="_blank" class="btn btn-sm btn-outline-primary mr-2">
                        {{ $t('ver_en_youtube') }}
                      </a>
                      <b-button v-if="puedeEscribir" size="sm" variant="danger" @click="eliminarVideoItem(v.id)">
                        {{ $t('eliminar') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-muted mb-3">{{ $t('no_videos_guardados') }}</div>

            <hr />

            <h5>{{ $t('agregar_video_youtube') }}</h5>
            <div class="row align-items-end">
              <div class="col-md-8">
                <label class="filtro-label">{{ $t('url_video') }}</label>
                <input type="text" class="form-control" v-model="nuevoVideoItemUrl"
                  placeholder="https://www.youtube.com/watch?v=..." @input="validarVideoItemUrl" />
                <small v-if="videoItemUrlError" class="text-danger">{{ videoItemUrlError }}</small>
              </div>
              <div class="col-md-4">
                <b-button v-if="puedeEscribir" variant="success" @click="agregarVideoItem" :disabled="!videoItemUrlValido">
                  {{ $t('agregar_video') }}
                </b-button>
              </div>
            </div>

            <div v-if="videoItemUrlValido && nuevoVideoItemUrl" class="mt-3">
              <h6>{{ $t('vista_previa') }}:</h6>
              <div class="video-preview-small">
                <iframe :src="getYoutubeEmbedUrl(nuevoVideoItemUrl)" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen class="video-iframe-small"></iframe>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>

    <!-- =============================== -->
    <!-- MODAL TÉRMINOS Y CONDICIONES -->
    <!-- =============================== -->
    <b-modal v-model="modalTerminos" :title="$t('terminos_condiciones')" size="lg">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <small class="text-muted">{{ $t('terminos_pago') || 'Términos de Pago' }}</small>
        <b-button size="sm" variant="outline-secondary" @click="usarTextoEjemplo">
          {{ $t('usar_texto_ejemplo') }}
        </b-button>
      </div>
      <textarea
        v-model="terminosContenido"
        class="form-control"
        rows="12"
        style="font-size:13px;resize:vertical;"
      ></textarea>
      <div class="mt-3 text-right">
        <b-button v-if="puedeEscribir" variant="primary" @click="guardarTerminos">
          {{ $t('guardar') }}
        </b-button>
      </div>
    </b-modal>

    <!-- =============================== -->
    <!-- MODAL FOTOS Y VIDEOS CLUSTER -->
    <!-- =============================== -->
    <b-modal v-model="modalFotosCluster" :title="$t('fotos_videos_cluster')" size="xl">
      <div>
        <p><strong>Cluster:</strong> {{ clusterFotoActual ? clusterFotoActual.nombreCluster : "" }}</p>
        <p><strong>ID:</strong> #{{ clusterFotoActual ? clusterFotoActual.id : "" }}</p>

        <b-tabs content-class="mt-3">
          <!-- TAB FOTOS -->
          <b-tab :title="'📷 ' + $t('fotos')" active>
            <div v-if="fotosClusterActuales.length" class="mb-3">
              <h5>{{ $t('fotos_guardadas') }}</h5>
              <div class="row">
                <div v-for="(f, i) in fotosClusterActuales" :key="i" class="col-4 mb-3 text-center">
                  <img :src="f.url" class="img-fluid bordered rounded" />
                  <div class="mt-2">
                    <b-form-checkbox
                      :disabled="!puedeEscribir"
                      :checked="Boolean(f.esPortada)"
                      @change="marcarFotoPrincipalCluster(f)"
                    >
                      Principal
                    </b-form-checkbox>
                  </div>
                  <b-button v-if="puedeEscribir" class="mt-2" variant="danger" size="sm" @click="eliminarFotoCluster(f.id)">
                    {{ $t('eliminar') }}
                  </b-button>
                </div>
              </div>
            </div>
            <div v-else class="text-muted mb-3">{{ $t('no_fotos_guardadas') }}</div>

            <hr />

            <h5>{{ $t('subir_fotos') }}</h5>
            <small class="text-muted d-block mb-2">{{ $t('formatos_imagen_permitidos') }}</small>
            <small
              class="d-block mb-2"
              :class="cupoFotosCluster ? 'text-muted' : 'text-danger'"
            >
              {{ cupoFotosCluster
                ? $t('max_fotos_ayuda', { max: maxFotos, cupo: cupoFotosCluster })
                : $t('max_fotos_alcanzado', { max: maxFotos }) }}
            </small>
            <input
              ref="inputFotosCluster"
              type="file"
              multiple
              accept="image/jpeg,image/png,image/webp,image/gif"
              :disabled="!cupoFotosCluster"
              @change="onFileSelectCluster"
            />

            <b-button
              v-if="puedeEscribir"
              class="mt-3"
              variant="success"
              :disabled="!archivosSeleccionadosCluster.length"
              @click="subirFotosCluster"
            >
              {{ $t('subir_fotos') }}
            </b-button>
          </b-tab>

          <!-- TAB VIDEOS -->
          <b-tab :title="'🎬 ' + $t('videos')">
            <div v-if="videosClusterActuales.length" class="mb-4">
              <h5>{{ $t('videos_guardados') }}</h5>
              <div class="row">
                <div v-for="(v, i) in videosClusterActuales" :key="i" class="col-6 mb-3">
                  <div class="video-card">
                    <div class="video-preview">
                      <iframe :src="getYoutubeEmbedUrl(v.url)" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen class="video-iframe"></iframe>
                    </div>
                    <div class="video-actions mt-2 text-center">
                      <a :href="v.url" target="_blank" class="btn btn-sm btn-outline-primary mr-2">
                        {{ $t('ver_en_youtube') }}
                      </a>
                      <b-button v-if="puedeEscribir" size="sm" variant="danger" @click="eliminarVideoCluster(v.id)">
                        {{ $t('eliminar') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-muted mb-3">{{ $t('no_videos_guardados') }}</div>

            <hr />

            <h5>{{ $t('agregar_video_youtube') }}</h5>
            <div class="row align-items-end">
              <div class="col-md-8">
                <label class="filtro-label">{{ $t('url_video') }}</label>
                <input type="text" class="form-control" v-model="nuevoVideoClusterUrl"
                  placeholder="https://www.youtube.com/watch?v=..." @input="validarVideoClusterUrl" />
                <small v-if="videoClusterUrlError" class="text-danger">{{ videoClusterUrlError }}</small>
              </div>
              <div class="col-md-4">
                <b-button v-if="puedeEscribir" variant="success" @click="agregarVideoCluster" :disabled="!videoClusterUrlValido">
                  {{ $t('agregar_video') }}
                </b-button>
              </div>
            </div>

            <div v-if="videoClusterUrlValido && nuevoVideoClusterUrl" class="mt-3">
              <h6>{{ $t('vista_previa') }}:</h6>
              <div class="video-preview-small">
                <iframe :src="getYoutubeEmbedUrl(nuevoVideoClusterUrl)" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen class="video-iframe-small"></iframe>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { VueEditor } from "vue2-editor";
import materialService from "@/api/materialService";
import diccionarioService from "@/api/diccionarioService";
import utilsService from "@/api/utilsService";
import fichaService from "@/api/fichaService";
import Swal from 'sweetalert2';
import FichaPanel from "@/views/Ficha/Panel.vue";
import * as XLSX from "xlsx";

// Máximo de imágenes que se pueden tener por ítem y por cluster en Multimedia.
// Subido temporalmente de 10 a 200 a pedido del usuario.
const MAX_FOTOS = 200;

export default {
  name: "LecturaVentasInventarioView",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    VueEditor,
    FichaPanel
  },

  data() {
    return {
      lang: localStorage.getItem('language') || 'es',
      taxByCategoria: {},
      condicionesOptions: [],
      modalFotos: false,
      modalTerminos: false,
      modalFotosCluster: false,

      fotoActual: null,
      fotosActuales: [],
      archivosSeleccionados: [],

      // Videos de item (búsqueda global)
      videosItemActuales: [],
      nuevoVideoItemUrl: "",
      videoItemUrlValido: false,
      videoItemUrlError: "",

      // Fotos de cluster
      clusterFotoActual: null,
      fotosClusterActuales: [],
      archivosSeleccionadosCluster: [],

      // Videos de cluster
      videosClusterActuales: [],
      nuevoVideoClusterUrl: "",
      videoClusterUrlValido: false,
      videoClusterUrlError: "",

      terminoActual: null,
      terminosContenido: "",

      textoBusqueda: "",
      resultadosBusqueda: [],

      buscarFichaTexto: "",
      buscandoFicha: false,
      clusterDestacadoId: null,

      empresasCliente: [],

      archivosLogs: [],
      archivosFiltrados: [],
      archivoSeleccionado: null,
      archivosConsultados: false,

      resumenClusters: [],
      tokenActual: null,

      clusterSeleccionado: null,

      // Filtros para búsqueda global
      filtrosBusqueda: {
        cliente: "",
        archivo: "",
        cluster: "",
        detalleId: "",
        familia: "",
        fabricante: "",
        brandName: "",
        partNumber: "",
        partName: "",
        modelo: "",
        condicion: "",
        detalles: "",
        cantidad: "",
        valorSugerido: "",
        valorTotalSugerido: "",
        cantidadDisponible: "",
        publicacion: ""
      },

      // Filtros para tabla Resumen de Clusters
      filtrosResumen: {
        id: "",
        nombreCluster: "",
        criterio: "",
        fechaCreacion: "",
        cantidadItems: "",
        conMultimedia: false,
        conFicha: false,
        publicacion: ""
      },

      opcionesCondicionBusqueda: [
        { value: "", text: this.$t('todos') },
        { value: "NUEVO", text: "NUEVO" },
        { value: "USADO", text: "USADO" },
        { value: "Reparado", text: "Reparado" },
        { value: "Remanufacturado", text: "Remanufacturado" }
      ],

      opcionesPublicacion: [
        { value: "", text: this.$t('estado_todos') },
        { value: "N", text: this.$t('pub_no_publicado') },
        { value: "S", text: this.$t('pub_solicitado') },
        { value: "P", text: this.$t('pub_publicado') },
        { value: "D", text: this.$t('pub_despublicacion_solicitada') }
      ],

      // Ordenamiento de tabla clusters
      ordenColumna: null,
      ordenDireccion: 'asc', // 'asc' o 'desc'

      // Ordenamiento de tabla resultados búsqueda
      ordenColumnaResultados: null,
      ordenDireccionResultados: 'asc',

      // Paginación tabla Resumen de Clusters
      paginaResumen: 1,
      pageSizeResumen: 50,

      // Paginación tabla Resultados Búsqueda
      paginaResultados: 1,
      pageSizeResultados: 50,

      // Filtro y orden tabla Archivos Cargados
      filterColArchivos: {
        nombreXLSX: '',
        estadoFlujoDesc: '',
        fechaRentabilizacion: '',
        fechaClusterizacion: '',
        tipoFlujo: '',
      },
      ordenColumnaArchivos: null,
      ordenDireccionArchivos: 'asc',

      ultimaSincronizacionPortal: null
    };
  },

  computed: {
    maxFotos() {
      return MAX_FOTOS;
    },
    // Cuántas imágenes más se pueden subir al ítem / al cluster sin pasar el máximo.
    cupoFotosItem() {
      return Math.max(0, MAX_FOTOS - this.fotosActuales.length);
    },
    cupoFotosCluster() {
      return Math.max(0, MAX_FOTOS - this.fotosClusterActuales.length);
    },

    empresaSeleccionada: {
      get() { return this.$store.getters.empresaActiva; },
      set(val) { this.$store.dispatch('setEmpresaActiva', val); },
    },
    rol() {
      return (utilsService.getRol() || '').toLowerCase().trim();
    },
    showEmpresaBadge() {
      return (this.rol === 'cliente' || this.rol === 'ventas inex') && this.empresasCliente.length === 1;
    },
    nombreEmpresaSeleccionada() {
      const e = (this.empresasCliente || []).find(x => x.id === this.empresaSeleccionada);
      return e ? (e.nombre || '') : '';
    },
    ecommerceUrl() {
      return (process.env.VUE_APP_ECOMMERCE_URL || "https://ecommerce.inexlink.com").replace(/\/+$/, "");
    },
    modoBusquedaGlobal() {
      return this.resultadosBusqueda.length > 0;
    },

    ultimaSincronizacionPortalTexto() {
      if (!this.ultimaSincronizacionPortal) return "--";
      const date = new Date(this.ultimaSincronizacionPortal);
      if (isNaN(date.getTime())) return "--";
      return date.toLocaleString("es-CL", {
        timeZone: "America/Santiago",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    resultadosFiltrados() {
      const filtrados = this.resultadosBusqueda.filter(r => {
        if (this.filtrosBusqueda.cliente &&
          !String(r.cliente || "").toLowerCase().includes(this.filtrosBusqueda.cliente.toLowerCase())) return false;
        if (this.filtrosBusqueda.archivo &&
          !String(r.archivo || "").toLowerCase().includes(this.filtrosBusqueda.archivo.toLowerCase())) return false;
        if (this.filtrosBusqueda.cluster &&
          !String(r.cluster || "").toLowerCase().includes(this.filtrosBusqueda.cluster.toLowerCase())) return false;
        if (this.filtrosBusqueda.detalleId &&
          !String(r.detalleId || "").includes(this.filtrosBusqueda.detalleId)) return false;
        if (this.filtrosBusqueda.familia &&
          !String(r.familia || "").toLowerCase().includes(this.filtrosBusqueda.familia.toLowerCase())) return false;
        if (this.filtrosBusqueda.fabricante &&
          !String(r.fabricante || "").toLowerCase().includes(this.filtrosBusqueda.fabricante.toLowerCase())) return false;
        if (this.filtrosBusqueda.brandName &&
          !String(r.brandName || "").toLowerCase().includes(this.filtrosBusqueda.brandName.toLowerCase())) return false;
        if (this.filtrosBusqueda.partNumber &&
          !String(r.partNumber || "").toLowerCase().includes(this.filtrosBusqueda.partNumber.toLowerCase())) return false;
        if (this.filtrosBusqueda.partName &&
          !String(r.partName || "").toLowerCase().includes(this.filtrosBusqueda.partName.toLowerCase())) return false;
        if (this.filtrosBusqueda.modelo &&
          !String(r.modelo || "").toLowerCase().includes(this.filtrosBusqueda.modelo.toLowerCase())) return false;
        if (this.filtrosBusqueda.condicion &&
          r.condicion !== this.filtrosBusqueda.condicion) return false;
        if (this.filtrosBusqueda.detalles &&
          !String(r.detalles || "").toLowerCase().includes(this.filtrosBusqueda.detalles.toLowerCase())) return false;
        if (this.filtrosBusqueda.cantidad &&
          !String(r.cantidad == null ? "" : r.cantidad).includes(this.filtrosBusqueda.cantidad)) return false;
        if (this.filtrosBusqueda.valorSugerido &&
          !String(r.valorSugerido == null ? "" : r.valorSugerido).includes(this.filtrosBusqueda.valorSugerido)) return false;
        if (this.filtrosBusqueda.valorTotalSugerido &&
          !String(r.valorTotalSugerido == null ? "" : r.valorTotalSugerido).includes(this.filtrosBusqueda.valorTotalSugerido)) return false;
        if (this.filtrosBusqueda.cantidadDisponible &&
          !String(r.cantidadDisponible == null ? "" : r.cantidadDisponible).includes(this.filtrosBusqueda.cantidadDisponible)) return false;
        if (this.filtrosBusqueda.publicacion) {
          const pub = r.estadoPublicacion || "N";
          if (pub !== this.filtrosBusqueda.publicacion) return false;
        }
        return true;
      });

      // Aplicar ordenamiento si hay columna seleccionada
      if (!this.ordenColumnaResultados) {
        return filtrados;
      }

      const resultados = [...filtrados];

      resultados.sort((a, b) => {
        let valorA = a[this.ordenColumnaResultados];
        let valorB = b[this.ordenColumnaResultados];

        // Manejo de valores nulos/undefined
        if (valorA === null || valorA === undefined) valorA = '';
        if (valorB === null || valorB === undefined) valorB = '';

        // Conversión para números
        if (typeof valorA === 'number' && typeof valorB === 'number') {
          return this.ordenDireccionResultados === 'asc' ? valorA - valorB : valorB - valorA;
        }

        // Conversión para strings (case insensitive)
        valorA = String(valorA).toLowerCase();
        valorB = String(valorB).toLowerCase();

        if (valorA < valorB) return this.ordenDireccionResultados === 'asc' ? -1 : 1;
        if (valorA > valorB) return this.ordenDireccionResultados === 'asc' ? 1 : -1;
        return 0;
      });

      return resultados;
    },

    processedArchivosLogs() {
      const f = this.filterColArchivos;
      let rows = (this.archivosLogs || []).filter(a => {
        for (const k in f) {
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          // para estado buscar en desc o en el código
          const cell = k === 'estadoFlujoDesc'
            ? (String(a.estadoFlujoDesc || '') + ' ' + String(a.estadoFlujo || '')).toLowerCase()
            : String(a[k] == null ? '' : a[k]).toLowerCase();
          if (!cell.includes(needle)) return false;
        }
        return true;
      });

      if (this.ordenColumnaArchivos) {
        const key = this.ordenColumnaArchivos;
        const dir = this.ordenDireccionArchivos === 'asc' ? 1 : -1;
        rows = [...rows].sort((a, b) => {
          let va = a[key] == null ? '' : a[key];
          let vb = b[key] == null ? '' : b[key];
          if (!isNaN(Date.parse(va)) && !isNaN(Date.parse(vb))) {
            return (new Date(va) - new Date(vb)) * dir;
          }
          va = String(va).toLowerCase();
          vb = String(vb).toLowerCase();
          return va < vb ? -dir : va > vb ? dir : 0;
        });
      }
      return rows;
    },

    // Igual que la columna "Categoria Inexlink" de MaterialesResultFile.vue: valor en español,
    // con equivalente en ingles desde dbo.Taxonomias para mostrar segun el idioma activo.
    opcionesCategoriaResumen() {
      const locale = this.lang === 'en' ? 'en' : 'es';
      return Object.keys(this.taxByCategoria)
        .map(cat => ({ label: this._catLabel(cat), value: cat }))
        .sort((a, b) => a.label.localeCompare(b.label, locale, { sensitivity: 'base' }));
    },

    // Igual que la columna "Condicion" de MaterialesResultFile.vue: valores desde Diccionarios (Tipo='CONDICION').
    opcionesCondicionResumen() {
      const locale = this.lang === 'en' ? 'en' : 'es';
      return this.condicionesOptions
        .map(opt => ({ label: (this.lang === 'en' ? opt.nombreIngles : opt.nombre) || '', value: Number(opt.id) }))
        .sort((a, b) => a.label.localeCompare(b.label, locale, { sensitivity: 'base' }));
    },

    resumenClustersFiltrados() {
      const f = this.filtrosResumen;
      return (this.resumenClusters || []).filter(c => {
        if (f.id && !String(c.id).includes(f.id)) return false;
        if (f.nombreCluster &&
          !String(c.nombreCluster || "").toLowerCase().includes(f.nombreCluster.toLowerCase())) return false;
        if (f.criterio &&
          !String(c.criterio || "").toLowerCase().includes(f.criterio.toLowerCase())) return false;
        if (f.fechaCreacion &&
          !this.formatDate(c.fechaCreacion).toLowerCase().includes(f.fechaCreacion.toLowerCase())) return false;
        if (f.cantidadItems &&
          !String(c.cantidadItems == null ? "" : c.cantidadItems).includes(f.cantidadItems)) return false;
        if (f.conMultimedia) {
          const tieneFotos = Number(c.cantidadFotos) > 0;
          const tieneVideos = Number(c.cantidadVideos) > 0;
          if (!tieneFotos && !tieneVideos) return false;
        }
        if (f.conFicha) {
          if (!c.idFicha || c.idFicha <= 0) return false;
        }
        if (f.publicacion) {
          const pub = c.estadoPublicacion || "N";
          if (pub !== f.publicacion) return false;
        }
        return true;
      });
    },

    // Order grilla Resumen CLusters
    resumenClustersOrdenados() {
      if (!this.ordenColumna) {
        return this.resumenClustersFiltrados;
      }

      const clusters = [...this.resumenClustersFiltrados];

      clusters.sort((a, b) => {
        let valorA = a[this.ordenColumna];
        let valorB = b[this.ordenColumna];

        // Manejo de valores nulos/undefined
        if (valorA === null || valorA === undefined) valorA = '';
        if (valorB === null || valorB === undefined) valorB = '';

        // Conversión para números
        if (typeof valorA === 'number' && typeof valorB === 'number') {
          return this.ordenDireccion === 'asc' ? valorA - valorB : valorB - valorA;
        }

        // Conversión para strings (case insensitive)
        valorA = String(valorA).toLowerCase();
        valorB = String(valorB).toLowerCase();

        if (valorA < valorB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (valorA > valorB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });

      return clusters;
    },

    totalPagesResumen() {
      if (this.pageSizeResumen >= 999999) return 1;
      return Math.max(1, Math.ceil(this.resumenClustersOrdenados.length / this.pageSizeResumen));
    },

    resumenClustersPaginado() {
      if (this.pageSizeResumen >= 999999) return this.resumenClustersOrdenados;
      const start = (this.paginaResumen - 1) * this.pageSizeResumen;
      return this.resumenClustersOrdenados.slice(start, start + this.pageSizeResumen);
    },

    totalPagesResultados() {
      if (this.pageSizeResultados >= 999999) return 1;
      return Math.max(1, Math.ceil(this.resultadosFiltrados.length / this.pageSizeResultados));
    },

    resultadosPaginados() {
      if (this.pageSizeResultados >= 999999) return this.resultadosFiltrados;
      const start = (this.paginaResultados - 1) * this.pageSizeResultados;
      return this.resultadosFiltrados.slice(start, start + this.pageSizeResultados);
    }
  },

  watch: {
    filtrosResumen: { deep: true, handler() { this.paginaResumen = 1; } },
    filtrosBusqueda: { deep: true, handler() { this.paginaResultados = 1; } },
  },


  async mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this.cargarTaxonomias();
    this.loadCondiciones();
    try {
      await this.cargarUltimaSincronizacionPortal();

      const resp = await materialService.getEmpresasAsociadas();
      let data = resp;
      if (resp && typeof resp === "object") {
        if ("data" in resp) data = resp.data;
        else if ("items" in resp) data = resp.items;
      }
      this.empresasCliente = Array.isArray(data) ? data : [];

      // Restaurar estado guardado si existe
      await this.restaurarEstado();
    } catch (err) {
      console.error("❌ Error cargando empresas", err);
    }
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    // Guardar estado antes de destruir el componente
    this.guardarEstado();
  },

  methods: {

    formatFechaGmt0(valor) {
      if (!valor) return '—';
      // No se usa Date(): el valor ya viene en GMT 0 desde la BD y Date()
      // lo reinterpretaría como hora local del navegador, corriendo la hora.
      // Se extrae el texto tal cual (YYYY-MM-DD HH:mm) sin conversión de zona horaria.
      const match = String(valor).match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})/);
      return match ? `${match[1]} ${match[2]}` : String(valor);
    },

    scrollTabla(dir) {
      const el = this.modoBusquedaGlobal ? this.$refs.tablaResultados : this.$refs.tablaResumen;
      if (dir === 'left') { el && el.scrollBy({ left: -300, behavior: 'smooth' }); }
      else if (dir === 'right') { el && el.scrollBy({ left: 300, behavior: 'smooth' }); }
      else if (dir === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      else if (dir === 'bottom') { window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); }
    },


    /**
     * Da de baja todo lo asociado al archivo: fichas, clusters del resumen y ranking.
     * Solo se ofrece al volver a Administración de Inventario, porque ese camino rehace
     * rentabilización y clusterización desde cero y esos clusters dejan de corresponder.
     */
    async eliminarFichasYClustersDelArchivo(token) {
      const confirm = await Swal.fire({
        icon: 'warning',
        title: this.$t('confirmar_eliminar_fichas'),
        text: this.$t('accion_irreversible'),
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar_igualmente'),
        confirmButtonColor: '#d33',
        cancelButtonText: this.$t('cancelar'),
        reverseButtons: true
      });
      if (!confirm.isConfirmed) return false;

      try {
        const apiBase = process.env.VUE_APP_API_URL || '';
        const resp = await fetch(
          `${apiBase}/api/cluster/desactivarFichasPublicadasPorToken/${encodeURIComponent(token)}`,
          {
            method: 'PUT',
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
              'Accept': 'application/json'
            }
          }
        );
        if (!resp.ok) throw new Error(await resp.text());
        return true;
      } catch (e) {
        console.error('Error al desactivar fichas y clusters:', e);
        Swal.fire({
          icon: 'error',
          title: this.$t('error') || 'Error',
          text: this.$t('no_se_pudo_eliminar') || 'No se pudo eliminar.'
        });
        return false;
      }
    },

    async confirmarVolverAdmInventario(archivo) {
      if (!this.puedeEscribir) return;
      const token = archivo && String(archivo.token || '').trim();
      if (!token) return;

      // Verificar si hay fichas publicadas antes de permitir volver
      try {
        const apiBase = process.env.VUE_APP_API_URL || '';
        const resp = await fetch(
          `${apiBase}/api/cluster/getFichasPublicadasPorToken/${encodeURIComponent(token)}`,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('user-session'),
              'Accept': 'application/json'
            }
          }
        );

        if (resp.ok) {
          const data = await resp.json();
          if (Array.isArray(data) && data.length > 0) {
            // Solo el nombre del archivo (sin duplicar): pueden ser cientos de fichas
            const nombresArchivos = [...new Set(data.map(f => f.nombreXLSX || '—'))];
            const items = nombresArchivos.map(n => `<li style="margin-bottom:4px"><b>${n}</b></li>`).join('');

            // SweetAlert2 v9 no tiene showDenyButton: el tercer botón va dentro del html.
            let eliminarIgualmenteClicked = false;
            const result = await Swal.fire({
              icon: 'error',
              title: this.$t('no_permitido'),
              html: `<p>${this.$t('archivo_fichas_publicadas')}</p>
                     <ul style="text-align:left;padding-left:1.2rem">${items}</ul>
                     <p style="margin-top:8px"><b>${this.$t('revise_modulo_ecommerce')}</b></p>
                   <button id="btnEliminarIgualmente" type="button" class="btn btn-sm btn-danger mt-2">
                     ${this.$t('eliminar_igualmente')}
                   </button>`,
              confirmButtonText: this.$t('entendido'),
              showCancelButton: true,
              cancelButtonText: this.$t('ir_a_ficha'),
              cancelButtonColor: '#17a2b8',
              onOpen: (popup) => {
                const btn = popup.querySelector('#btnEliminarIgualmente');
                if (btn) {
                  btn.addEventListener('click', () => { eliminarIgualmenteClicked = true; Swal.close(); });
                }
              }
            });

            // Liberado el archivo, se reintenta la misma acción: la validación ya no bloquea.
            if (eliminarIgualmenteClicked) {
              const liberado = await this.eliminarFichasYClustersDelArchivo(token);
              if (liberado) return this.confirmarVolverAdmInventario(archivo);
              return;
            }

            if (result.dismiss === Swal.DismissReason.cancel) {
              sessionStorage.setItem('lecturaVentasEstado', JSON.stringify({
                empresaSeleccionada: this.empresaSeleccionada,
                tokenActual: token,
                archivoSeleccionado: archivo
              }));
              window.open('/lectura-ventas-inventario', '_blank');
            }
            return; // bloquear la acción
          }
        }
      } catch (e) {
        console.error('Error al verificar fichas publicadas:', e);
      }

      // Sin fichas publicadas: confirmar y ejecutar
      const res = await Swal.fire({
        title: this.$t('confirmar_volver_adm_inventario') || '¿Volver a la Administración de Materiales?',
        text: this.$t('texto_volver_adm_inventario') || 'Volverá a la Administración de Materiales. Deberá ejecutar el proceso de RENTABILIDAD nuevamente.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('volver_adm_inventario') || 'Volver Adm. Inventario',
        cancelButtonText: this.$t('cancelar') || 'Cancelar',
        reverseButtons: true
      });

      if (!res.isConfirmed) return;

      try {
        const resp = await materialService.updateEstadoFlujo(token, 'P');
        if (resp && (resp.success === true || resp.Success === true)) {
          // Actualizar estado local en la tabla
          const idx = (this.archivosLogs || []).findIndex(a => (a.token || '') === token);
          if (idx !== -1) {
            this.$set(this.archivosLogs, idx, {
              ...this.archivosLogs[idx],
              estadoFlujo: 'P'
            });
          }
          this.$notify && this.$notify({ type: 'success', message: this.$t('volver_adm_inventario') || 'Volver Adm. Inventario' });
        } else {
          this.$notify && this.$notify({ type: 'warning', message: 'No se pudo actualizar el estado.' });
        }
      } catch (e) {
        console.error('Error al volver a adm. inventario:', e);
        this.$notify && this.$notify({ type: 'error', message: 'Error al actualizar el estado.' });
      }
    },

    fichaLimpiar() {
      if (this.$refs.fichaPanel) this.$refs.fichaPanel.limpiar()
    },
    fichaVerFicha() {
      if (this.$refs.fichaPanel) this.$refs.fichaPanel.verFicha()
    },
    fichaGuardar() {
      if (!this.puedeEscribir) return;
      if (this.$refs.fichaPanel) this.$refs.fichaPanel.guardar()
    },

    async onFichaGuardada(idFicha) {
      const result = await Swal.fire({
        title: this.$t('fichas_masivas_confirmar_titulo'),
        html: `${this.$t('fichas_masivas_post_guardar_texto')}<br><br><strong>${this.$t('fichas_masivas_post_guardar_advertencia')}</strong>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('fichas_masivas_post_guardar_btn'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#f5a623',
      });
      if (!result.isConfirmed) return;

      try {
        Swal.fire({
          title: this.$t('fichas_masivas_procesando'),
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });
        await fichaService.creaFichaMasiva(idFicha);
        await Swal.fire({
          title: this.$t('fichas_masivas_exito_titulo'),
          text: this.$t('fichas_masivas_exito_texto'),
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        });
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message || this.$t('fichas_masivas_error');
        Swal.fire('Error', msg, 'error');
      }
    },

    async cargarUltimaSincronizacionPortal() {
      try {
        const resp = await materialService.getUltimaSincronizacionPortal();
        this.ultimaSincronizacionPortal = (resp && resp.ultimaSincronizacionPortal) || null;
      } catch (error) {
        console.error("Error cargando última sincronización:", error);
        this.ultimaSincronizacionPortal = null;
      }
    },

    //Ini Ordenamiento de tabla clusters ----------------------------
    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        // Si ya está ordenado por esta columna, cambiar dirección
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        // Nueva columna, ordenar ascendente
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
    },

    obtenerIconoOrden(columna) {
      if (this.ordenColumna !== columna) {
        return '↕️'; // Sin ordenar
      }
      return this.ordenDireccion === 'asc' ? '↑' : '↓';
    },
    // Fin Ordenamiento de tabla clusters ----------------------------

    //Ini Ordenamiento de tabla resultados ----------------------------
    ordenarPorArchivos(col) {
      if (this.ordenColumnaArchivos === col) {
        this.ordenDireccionArchivos = this.ordenDireccionArchivos === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumnaArchivos = col;
        this.ordenDireccionArchivos = 'asc';
      }
    },
    iconoOrdenArchivos(col) {
      if (this.ordenColumnaArchivos !== col) return 'fas fa-sort text-muted';
      return this.ordenDireccionArchivos === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    ordenarPorResultados(columna) {
      if (this.ordenColumnaResultados === columna) {
        // Si ya está ordenado por esta columna, cambiar dirección
        this.ordenDireccionResultados = this.ordenDireccionResultados === 'asc' ? 'desc' : 'asc';
      } else {
        // Nueva columna, ordenar ascendente
        this.ordenColumnaResultados = columna;
        this.ordenDireccionResultados = 'asc';
      }
    },

    obtenerIconoOrdenResultados(columna) {
      if (this.ordenColumnaResultados !== columna) {
        return '↕️'; // Sin ordenar
      }
      return this.ordenDireccionResultados === 'asc' ? '↑' : '↓';
    },
    // Fin Ordenamiento de tabla resultados ----------------------------

    abrirModalFichaConId(cluster) {
      console.log('Abriendo modal ficha con cluster:', cluster);
      console.log('idTipoFicha del cluster:', cluster.idTipoFicha);
      this.clusterSeleccionado = cluster;
      if (this.$bvModal) {
        this.$bvModal.show('modal-ficha');
      }
    },

    async seleccionarArchivoDesdeTabla(archivo) {
      await this.onArchivoSeleccionado(archivo);
    },

    volverATabla() {
      this.archivoSeleccionado = null;
      this.resumenClusters = [];
      this.resultadosBusqueda = [];
      this.textoBusqueda = '';
    },

    async onEmpresaSeleccionada() {
      if (!this.empresaSeleccionada) return;

      this.archivosConsultados = false;
      this.archivosLogs = [];
      this.archivosFiltrados = [];
      this.archivoSeleccionado = null;
      this.resumenClusters = [];
      this.resultadosBusqueda = [];

      const logs = await materialService.getArchivosLogs(this.empresaSeleccionada);

      let arr = logs;
      if (logs && typeof logs === "object") {
        if ("data" in logs) arr = logs.data;
        else if ("items" in logs) arr = logs.items;
      }

      this.archivosLogs = Array.isArray(arr) ? arr : [];

      this.archivosFiltrados = this.archivosLogs.filter(x => {
        const est = (x.estadoFlujo || x.EstadoFlujo || "").toUpperCase();
        return est === "E";
      });

      this.archivosConsultados = true;
    },

    async onArchivoSeleccionado(a) {
      this.archivoSeleccionado = a;
      this.resultadosBusqueda = [];

      if (a && a.token) this.tokenActual = a.token;

      await this.cargarClustersResumen();
    },

    async cargarClustersResumen() {
      if (!this.archivoSeleccionado || !this.archivoSeleccionado.token) {
        console.warn("No hay token para cargar resumen.");
        return;
      }

      try {
        const data = await materialService.getClustersResumen(
          this.archivoSeleccionado.token
        );

        // Hacer copia profunda del array para que sea reactivo
        const dataArray = Array.isArray(data) ? data : [];
        this.resumenClusters = dataArray;

      } catch (e) {
        console.error("❌ Error cargando resumen clusters:", e);
        this.resumenClusters = [];
      }
    },

    mostrarInfoResumenCluster() {
      Swal.fire({
        icon: 'info',
        title: this.$t('informacion'),
        html: `<ul style="text-align:left;padding-left:1.2rem;margin-bottom:0;">
                 <li>${this.$t('info_resumen_cluster_nombre')}</li>
                 <li>${this.$t('info_resumen_cluster_campos')}</li>
               </ul>`,
      });
    },

    async cargarTaxonomias() {
      try {
        const rows = await materialService.getTaxonomias();
        const map = Object.create(null);
        (rows || []).forEach(r => {
          const cat = String(r.Categoria || r.categoria || '').trim();
          if (!cat) return;
          map[cat] = String(r.CategoriaIngles || r.categoriaIngles || '').trim();
        });
        this.taxByCategoria = map;
      } catch (e) {
        console.warn('[Taxonomias] no se pudo cargar:', e);
        this.taxByCategoria = {};
      }
    },

    _catLabel(cat) {
      if (this.lang !== 'en' || !cat) return cat;
      return this.taxByCategoria[cat] || cat;
    },

    async loadCondiciones() {
      try {
        const data = await diccionarioService.getByTipo('CONDICION');
        this.condicionesOptions = Array.isArray(data) ? data : [];
      } catch (e) {
        console.warn('[Condiciones] no se pudo cargar:', e);
        this.condicionesOptions = [];
      }
    },

    marcarDirtyResumen(c) {
      if (!this.puedeEscribir) return;
      this.$set(c, '_dirty', true);
    },

    async guardarCamposResumen(c) {
      if (!this.puedeEscribir) return;
      this.$set(c, '_saving', true);
      try {
        await materialService.updateCamposResumenCluster(c.id, {
          categoria: c.categoria || null,
          fabricante: c.fabricante || null,
          modelo: c.modelo || null,
          idCondicion: c.idCondicion || null,
        });
        this.$set(c, '_dirty', false);
        Swal.fire({ icon: 'success', title: this.$t('guardado'), timer: 1500, showConfirmButton: false });
      } catch (e) {
        console.error('[guardarCamposResumen] error:', e);
        Swal.fire('Error', this.$t('error_guardar_cambios'), 'error');
      } finally {
        this.$set(c, '_saving', false);
      }
    },

    // Igual que en ClusterizacionView.vue: "SIN INFORMACION" es un valor fijo en español que
    // ya trae MaterialesFileETL.CriterioPorMarca cuando falta la marca; se traduce en pantalla.
    nombreClusterParaMostrar(nombre) {
      const txt = String(nombre == null ? '' : nombre).trim();
      if (this.lang === 'en' && txt.toUpperCase() === 'SIN INFORMACION') {
        return this.$t('sin_informacion_cluster');
      }
      return nombre;
    },

    async editarNombreCustomCluster(c) {
      const id = c && (c.id != null ? c.id : c.Id);
      if (id == null) return;

      const actual = c.nombreCustom || c.NombreCustom || c.nombreCluster || '';
      const { value, isConfirmed } = await Swal.fire({
        title: this.$t('editar_nombre_cluster') || 'Editar nombre del cluster',
        input: 'text',
        inputValue: actual,
        inputPlaceholder: actual,
        showCancelButton: true,
        confirmButtonText: this.$t('guardar'),
        cancelButtonText: this.$t('cancelar'),
      });
      if (!isConfirmed) return;

      const nuevoNombre = (value || '').trim();
      try {
        await materialService.updateNombreCustomCluster([id], nuevoNombre || null);
        this.$set(c, 'nombreCustom', nuevoNombre || null);
        Swal.fire({ icon: 'success', title: this.$t('guardado'), timer: 1500, showConfirmButton: false });
      } catch (e) {
        console.error('[editarNombreCustomCluster] error:', e);
        Swal.fire('Error', this.$t('error_guardar_cambios') || 'No se pudo guardar el nombre.', 'error');
      }
    },

    async verDetalleCluster(c) {
      try {
        const token = this.tokenActual;

        const idCriterio = c.idCriterio
          || c.id_criterio
          || c.criterio
          || c.Criterio
          || this.archivoSeleccionado.idCriterio
          || this.archivoSeleccionado.IdCriterio;

        const numeroCluster = c.nombreCluster
          || c.numeroCluster
          || c.numero_cluster
          || c.id;

        const idCluster = c.id || c.Id || c.idCluster;

        const detalle = await materialService.getClustersDetalle(
          token,
          idCriterio,
          numeroCluster,
          idCluster,
          this.lang
        );

        // Guardar estado antes de navegar
        this.guardarEstado();

        this.$router.push({
          name: "ClusterDetalle",
          params: {
            detalle,
            // Solo para mostrar en el título/export del detalle: numeroCluster (arriba) sigue
            // siendo la llave real que ya se usó para pedir el detalle.
            nombreCluster: this.nombreClusterParaMostrar(c.nombreCustom || c.NombreCustom || c.nombreCluster),
            token,
            idCriterio,
            numeroCluster,
            idCluster
          }
        });

      } catch (e) {
        console.error("❌ Error obteniendo detalle del cluster:", e);
        alert("No se pudo cargar el detalle del cluster");
      }
    },

    // ======================================================================
    // BÚSQUEDA POR NRO DE FICHA
    // ======================================================================

    async buscarPorNroFicha() {
      const idFicha = parseInt(this.buscarFichaTexto, 10);
      if (!idFicha || idFicha <= 0) {
        Swal.fire(this.$t('atencion') || 'Atención', this.$t('ficha_numero_invalido'), 'warning');
        return;
      }

      this.buscandoFicha = true;
      this.clusterDestacadoId = null;

      try {
        const ficha = await fichaService.obtenerPorId(idFicha);
        if (!ficha || !ficha.token) {
          Swal.fire(this.$t('no_permitido') || 'Atención', this.$t('ficha_no_encontrada', { id: idFicha }), 'error');
          return;
        }

        const archivoLog = await materialService.getFileLog(ficha.token);
        const idEmpresaFicha = archivoLog ? (archivoLog.id != null ? archivoLog.id : archivoLog.Id) : null;
        if (!archivoLog || !idEmpresaFicha) {
          Swal.fire('Error', this.$t('ficha_error_archivo'), 'error');
          return;
        }

        const empresaValida = this.empresasCliente.find(e => e.id === idEmpresaFicha);
        if (!empresaValida) {
          Swal.fire(this.$t('no_permitido') || 'Atención', this.$t('ficha_sin_acceso_empresa'), 'error');
          return;
        }

        // 1) Setear empresa seleccionada y cargar sus archivos
        this.empresaSeleccionada = idEmpresaFicha;
        await this.onEmpresaSeleccionada();

        // 2) Ubicar y mostrar el archivo que contiene la ficha
        const archivoEncontrado = this.archivosLogs.find(a => a.token === ficha.token);
        if (!archivoEncontrado) {
          Swal.fire('Error', this.$t('ficha_error_archivo'), 'error');
          return;
        }

        await this.onArchivoSeleccionado(archivoEncontrado);

        // 3) Resaltar el cluster de la ficha encontrada (ubicando su página)
        this.clusterDestacadoId = ficha.idCluster;
        const posicion = this.resumenClustersOrdenados.findIndex(c => c.id === ficha.idCluster);
        if (posicion >= 0 && this.pageSizeResumen < 999999) {
          this.paginaResumen = Math.floor(posicion / this.pageSizeResumen) + 1;
        }
        this.$nextTick(() => {
          const el = this.$el.querySelector(`[data-cluster-id="${ficha.idCluster}"]`);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      } catch (e) {
        console.error('Error buscando ficha por Nro:', e);
        const status = e && e.response && e.response.status;
        if (status === 404) {
          Swal.fire(this.$t('no_permitido') || 'Atención', this.$t('ficha_no_encontrada', { id: idFicha }), 'error');
        } else {
          Swal.fire('Error', this.$t('ficha_error_archivo'), 'error');
        }
      } finally {
        this.buscandoFicha = false;
      }
    },

    // ======================================================================
    // BÚSQUEDA GLOBAL / FOTOS / T&C
    // ======================================================================

    async buscarGlobal() {
      if (!this.textoBusqueda || this.textoBusqueda.length < 3) {
        alert("Ingrese al menos 3 caracteres");
        return;
      }

      const resp = await materialService.buscarGlobal(this.textoBusqueda);

      this.resultadosBusqueda = Array.isArray(resp)
        ? resp.map(r => ({
          cliente: r.cliente,
          archivo: r.archivo,
          cluster: r.cluster,
          detalleId: r.detalleId,
          partNumber: r.partNumber,
          partName: r.partName,
          modelo: r.modelo,
          condicion: r.condicion,
          detalles: r.detalles,
          valorSugerido: r.valorSugerido,
          valorTotalSugerido: r.valorTotalSugerido,
          tokenArchivo: r.tokenArchivo,
          cantidadFotos: r.cantidadFotos || 0,
          cantidadVideos: r.cantidadVideos || 0,
          cantidad: r.cantidad,
          cantidadDisponible: r.cantidadDisponible,
          familia: r.familia,
          idFicha: r.idFicha || null,
          estadoPublicacion: r.estadoPublicacion || null,
          mongoSlug: r.mongoSlug || null
        }))
        : [];
    },

    async abrirModalFotos(item) {
      this.fotoActual = item;
      this.modalFotos = true;

      // Limpiar estado de video
      this.nuevoVideoItemUrl = "";
      this.videoItemUrlValido = false;
      this.videoItemUrlError = "";

      // Cargar fotos y videos en paralelo
      const [fotosResult, videosResult] = await Promise.allSettled([
        materialService.getFotosCluster(item.tokenArchivo, item.detalleId),
        materialService.getVideosItem(item.tokenArchivo, item.detalleId)
      ]);

      this.fotosActuales = fotosResult.status === 'fulfilled' ? (fotosResult.value || []) : [];
      this.videosItemActuales = videosResult.status === 'fulfilled' ? (videosResult.value || []) : [];
      await this.asegurarFotoPrincipalItem();
    },

    async asegurarFotoPrincipalItem() {
      if (!Array.isArray(this.fotosActuales) || this.fotosActuales.length !== 1) {
        return;
      }

      const unicaFoto = this.fotosActuales[0];
      if (unicaFoto && !unicaFoto.esPortada) {
        await materialService.marcarArchivoPrincipal(unicaFoto.id);
        unicaFoto.esPortada = true;
      }
    },

    async marcarFotoPrincipalItem(foto) {
      if (!this.puedeEscribir) return;
      try {
        await materialService.marcarArchivoPrincipal(foto.id);
        this.fotosActuales = this.fotosActuales.map(f => ({
          ...f,
          esPortada: f.id === foto.id
        }));
      } catch (e) {
        console.error("Error al marcar foto principal de item:", e);
        alert("Error al marcar la foto principal.");
      }
    },

    onFileSelect(e) {
      const seleccionados = Array.from(e.target.files || []);
      if (seleccionados.length > this.cupoFotosItem) {
        alert(this.$t('max_fotos_excedido', { max: MAX_FOTOS, cupo: this.cupoFotosItem }));
        e.target.value = "";
        this.archivosSeleccionados = [];
        return;
      }
      this.archivosSeleccionados = seleccionados;
    },

    async subirFotos() {
      if (!this.puedeEscribir) return;
      if (!this.archivosSeleccionados.length) {
        alert("Debe seleccionar al menos una foto.");
        return;
      }
      // Revalida por si se eliminaron o agregaron fotos después de elegir los archivos.
      if (this.archivosSeleccionados.length > this.cupoFotosItem) {
        alert(this.$t('max_fotos_excedido', { max: MAX_FOTOS, cupo: this.cupoFotosItem }));
        return;
      }

      const form = new FormData();
      form.append("token", this.fotoActual.tokenArchivo);
      form.append("detalleId", this.fotoActual.detalleId);

      this.archivosSeleccionados.forEach(f => form.append("files", f));

      await materialService.subirFotosCluster(form);

      const fotos = await materialService.getFotosCluster(
        this.fotoActual.tokenArchivo,
        this.fotoActual.detalleId
      );

      this.fotosActuales = fotos;
      await this.asegurarFotoPrincipalItem();

      // Actualizar contador en la tabla
      if (this.fotoActual) {
        this.fotoActual.cantidadFotos = Array.isArray(fotos) ? fotos.length : 0;
      }

      // Limpiar archivos seleccionados
      this.archivosSeleccionados = [];
      if (this.$refs.inputFotosItem) this.$refs.inputFotosItem.value = "";
    },

    eliminarFoto(id) {
      if (!this.puedeEscribir) return;
      const token = this.fotoActual.tokenArchivo;
      const detalleId = this.fotoActual.detalleId;

      materialService
        .eliminarFotoCluster(id)
        .then(() => materialService.getFotosCluster(token, detalleId))
        .then(fotos => {
          this.fotosActuales = fotos;
          return this.asegurarFotoPrincipalItem();
        })
        .then(() => {
          // Actualizar contador en la tabla
          if (this.fotoActual) {
            this.fotoActual.cantidadFotos = Array.isArray(this.fotosActuales) ? this.fotosActuales.length : 0;
          }
        })
        .catch(err => {
          console.error("Error al eliminar foto:", err);
          alert("Error al eliminar la foto");
        });
    },

    // ======================================================================
    // VIDEOS DE ITEM (Búsqueda Global)
    // ======================================================================

    validarVideoItemUrl() {
      this.videoItemUrlError = "";
      this.videoItemUrlValido = false;

      if (!this.nuevoVideoItemUrl) {
        return;
      }

      const embedUrl = this.getYoutubeEmbedUrl(this.nuevoVideoItemUrl);

      if (!embedUrl) {
        this.videoItemUrlError = "URL de YouTube no válida. Use formato: https://www.youtube.com/watch?v=... o https://youtu.be/...";
        return;
      }

      this.videoItemUrlValido = true;
    },

    async agregarVideoItem() {
      if (!this.puedeEscribir) return;
      if (!this.videoItemUrlValido || !this.nuevoVideoItemUrl) {
        alert("Ingrese una URL de YouTube válida");
        return;
      }

      try {
        await materialService.agregarVideoItem({
          token: this.fotoActual.tokenArchivo,
          detalleId: this.fotoActual.detalleId,
          url: this.nuevoVideoItemUrl
        });

        alert("Video agregado correctamente");

        const videos = await materialService.getVideosItem(
          this.fotoActual.tokenArchivo,
          this.fotoActual.detalleId
        );
        this.videosItemActuales = Array.isArray(videos) ? videos : [];

        // Actualizar contador en la tabla
        if (this.fotoActual) {
          this.fotoActual.cantidadVideos = this.videosItemActuales.length;
        }

        this.nuevoVideoItemUrl = "";
        this.videoItemUrlValido = false;
      } catch (e) {
        console.error("Error al agregar video:", e);
        alert("Error al agregar el video");
      }
    },

    async eliminarVideoItem(idVideo) {
      if (!this.puedeEscribir) return;
      if (!confirm("¿Eliminar este video?")) return;

      try {
        await materialService.eliminarVideoItem(idVideo);

        const videos = await materialService.getVideosItem(
          this.fotoActual.tokenArchivo,
          this.fotoActual.detalleId
        );
        this.videosItemActuales = Array.isArray(videos) ? videos : [];

        // Actualizar contador en la tabla
        if (this.fotoActual) {
          this.fotoActual.cantidadVideos = this.videosItemActuales.length;
        }
      } catch (e) {
        console.error("Error al eliminar video:", e);
        alert("Error al eliminar el video");
      }
    },

    abrirModalTerminos(item) {
      this.terminoActual = item;

      materialService
        .getTerminosCluster(item.tokenArchivo, item.detalleId)
        .then(t => {
          this.terminosContenido = t && t.contenido ? t.contenido : "";
          this.modalTerminos = true;
        });
    },

    async guardarTerminos() {
      if (!this.puedeEscribir) return;
      await materialService.guardarTerminosCluster({
        tokenArchivo: this.terminoActual.tokenArchivo,
        detalleId: this.terminoActual.detalleId,
        contenido: this.terminosContenido
      });

      alert("Términos guardados");
      this.modalTerminos = false;
    },

    usarTextoEjemplo() {
      this.terminosContenido =
`Español:
- Garantía: En caso de adjudicación, el cliente comprador deberá abonar el 15% del valor ofertado dentro de los 3 días hábiles siguientes a la notificación de adjudicación. Este pago actúa como garantía para reservar el inventario y avanzar con el proceso de venta.
 Respecto de la garantía, la única razón por la cual podrá ser devuelta es que el cliente vendedor desista de la transacción.
 En caso de no cumplir con este requisito en el plazo establecido, la oferta será anulada automáticamente.

-Pago del Saldo Final: El cliente comprador adjudicado deberá abonar el 85% restante del valor total de la transacción con al menos 2 días de antelación al retiro del inventario y, además, dentro del plazo que ocurra primero de los siguientes dos escenarios:
 1. Dentro de los 15 días corridos desde la aceptación de la orden de compra.
 2. Dentro del mes en curso en que se haya emitido la factura correspondiente.

 En caso de no cumplir con esta condición en los plazos establecidos, la oferta será anulada automáticamente y la garantía no será devuelta.

English:
- Guarantee: Upon award, the purchasing client must pay 15% of the offered value within 3 business days following the award notification. This payment acts as a guarantee to reserve the inventory and proceed with the sales process.
 Regarding the guarantee, the only reason it may be returned is if the selling client withdraws from the transaction.
 Failure to meet this requirement within the established deadline will result in the offer being automatically cancelled.

- Final Balance Payment: The awarded purchasing client must pay the remaining 85% of the total transaction value at least 2 days before inventory pickup, and also within whichever of the following two scenarios occurs first:
 1. Within 15 calendar days from the acceptance of the purchase order.
 2. Within the current month in which the corresponding invoice was issued.

 Failure to meet this condition within the established deadlines will result in the offer being automatically cancelled and the guarantee will not be returned.`;
    },

    number(v) {
      if (!v) return "";
      const n = Number(v);
      return isNaN(n) ? v : n.toLocaleString("es-CL");
    },

    formatDate(v) {
      if (!v) return "";
      return new Date(v).toLocaleDateString("es-CL");
    },

    // ======================================================================
    // FOTOS DE CLUSTER
    // ======================================================================

    async abrirModalFotosCluster(cluster) {
      this.clusterFotoActual = cluster;
      this.modalFotosCluster = true;

      // Limpiar estado de video
      this.nuevoVideoClusterUrl = "";
      this.videoClusterUrlValido = false;
      this.videoClusterUrlError = "";

      try {
        const fotos = await materialService.getFotosClusterResumen(
          this.tokenActual,
          cluster.id
        );
        this.fotosClusterActuales = Array.isArray(fotos) ? fotos : [];
        await this.asegurarFotoPrincipalCluster();
      } catch (e) {
        console.error("Error al cargar fotos del cluster:", e);
        this.fotosClusterActuales = [];
      }

      // Cargar videos del cluster
      try {
        const videos = await materialService.getVideosClusterResumen(
          this.tokenActual,
          cluster.id
        );
        this.videosClusterActuales = Array.isArray(videos) ? videos : [];
      } catch (e) {
        console.error("Error al cargar videos del cluster:", e);
        this.videosClusterActuales = [];
      }
    },

    async asegurarFotoPrincipalCluster() {
      if (!Array.isArray(this.fotosClusterActuales) || this.fotosClusterActuales.length !== 1) {
        return;
      }

      const unicaFoto = this.fotosClusterActuales[0];
      if (unicaFoto && !unicaFoto.esPortada) {
        await materialService.marcarArchivoPrincipal(unicaFoto.id);
        unicaFoto.esPortada = true;
      }
    },

    async marcarFotoPrincipalCluster(foto) {
      if (!this.puedeEscribir) return;
      try {
        await materialService.marcarArchivoPrincipal(foto.id);
        this.fotosClusterActuales = this.fotosClusterActuales.map(f => ({
          ...f,
          esPortada: f.id === foto.id
        }));
      } catch (e) {
        console.error("Error al marcar foto principal del cluster:", e);
        alert("Error al marcar la foto principal.");
      }
    },

    onFileSelectCluster(e) {
      const seleccionados = Array.from(e.target.files || []);
      if (seleccionados.length > this.cupoFotosCluster) {
        alert(this.$t('max_fotos_excedido', { max: MAX_FOTOS, cupo: this.cupoFotosCluster }));
        e.target.value = "";
        this.archivosSeleccionadosCluster = [];
        return;
      }
      this.archivosSeleccionadosCluster = seleccionados;
    },

    async subirFotosCluster() {
      if (!this.puedeEscribir) return;
      if (!this.archivosSeleccionadosCluster.length) {
        alert("Debe seleccionar al menos una foto.");
        return;
      }
      // Revalida por si se eliminaron o agregaron fotos después de elegir los archivos.
      if (this.archivosSeleccionadosCluster.length > this.cupoFotosCluster) {
        alert(this.$t('max_fotos_excedido', { max: MAX_FOTOS, cupo: this.cupoFotosCluster }));
        return;
      }

      const form = new FormData();
      form.append("token", this.tokenActual);
      form.append("clusterId", this.clusterFotoActual.id);

      this.archivosSeleccionadosCluster.forEach(f => form.append("files", f));

      try {
        await materialService.subirFotosClusterResumen(form);

        const fotos = await materialService.getFotosClusterResumen(
          this.tokenActual,
          this.clusterFotoActual.id
        );

        this.fotosClusterActuales = Array.isArray(fotos) ? fotos : [];
        await this.asegurarFotoPrincipalCluster();

        // Actualizar contador en la tarjeta
        this.actualizarContadorFotosCluster(this.clusterFotoActual.id, this.fotosClusterActuales.length);

        this.archivosSeleccionadosCluster = [];
        if (this.$refs.inputFotosCluster) this.$refs.inputFotosCluster.value = "";
        alert("Fotos subidas correctamente");
      } catch (e) {
        console.error("Error al subir fotos del cluster:", e);
        alert("Error al subir fotos");
      }
    },

    async eliminarFotoCluster(idFoto) {
      if (!this.puedeEscribir) return;
      try {
        await materialService.eliminarFotoClusterResumen(idFoto);

        const fotos = await materialService.getFotosClusterResumen(
          this.tokenActual,
          this.clusterFotoActual.id
        );

        this.fotosClusterActuales = Array.isArray(fotos) ? fotos : [];
        await this.asegurarFotoPrincipalCluster();

        // Actualizar contador en la tarjeta
        this.actualizarContadorFotosCluster(this.clusterFotoActual.id, this.fotosClusterActuales.length);
      } catch (e) {
        console.error("Error al eliminar foto del cluster:", e);
        alert("Error al eliminar la foto");
      }
    },

    actualizarContadorFotosCluster(clusterId, cantidad) {
      const index = this.resumenClusters.findIndex(c => c.id === clusterId);
      if (index !== -1) {
        this.$set(this.resumenClusters, index, { ...this.resumenClusters[index], cantidadFotos: cantidad });
      }
    },

    actualizarContadorVideosCluster(clusterId, cantidad) {
      const index = this.resumenClusters.findIndex(c => c.id === clusterId);
      if (index !== -1) {
        this.$set(this.resumenClusters, index, { ...this.resumenClusters[index], cantidadVideos: cantidad });
      }
    },

    // ======================================================================
    // VIDEOS DE CLUSTER
    // ======================================================================

    getYoutubeEmbedUrl(url) {
      if (!url) return "";

      let videoId = "";

      const watchMatch = url.match(/[?&]v=([^&]+)/);
      if (watchMatch) {
        videoId = watchMatch[1];
      }

      const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
      if (shortMatch) {
        videoId = shortMatch[1];
      }

      const embedMatch = url.match(/youtube\.com\/embed\/([^?&]+)/);
      if (embedMatch) {
        videoId = embedMatch[1];
      }

      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }

      return "";
    },

    validarVideoClusterUrl() {
      this.videoClusterUrlError = "";
      this.videoClusterUrlValido = false;

      if (!this.nuevoVideoClusterUrl) {
        return;
      }

      const embedUrl = this.getYoutubeEmbedUrl(this.nuevoVideoClusterUrl);

      if (!embedUrl) {
        this.videoClusterUrlError = "URL de YouTube no válida. Use formato: https://www.youtube.com/watch?v=... o https://youtu.be/...";
        return;
      }

      this.videoClusterUrlValido = true;
    },

    async agregarVideoCluster() {
      if (!this.puedeEscribir) return;
      if (!this.videoClusterUrlValido || !this.nuevoVideoClusterUrl) {
        alert("Ingrese una URL de YouTube válida");
        return;
      }

      try {
        await materialService.agregarVideoClusterResumen({
          token: this.tokenActual,
          clusterId: this.clusterFotoActual.id,
          url: this.nuevoVideoClusterUrl
        });

        alert("Video agregado correctamente");

        const videos = await materialService.getVideosClusterResumen(
          this.tokenActual,
          this.clusterFotoActual.id
        );
        this.videosClusterActuales = Array.isArray(videos) ? videos : [];

        // Actualizar contador en la tarjeta
        this.actualizarContadorVideosCluster(this.clusterFotoActual.id, this.videosClusterActuales.length);

        this.nuevoVideoClusterUrl = "";
        this.videoClusterUrlValido = false;
      } catch (e) {
        console.error("Error al agregar video del cluster:", e);
        alert("Error al agregar el video");
      }
    },

    async eliminarVideoCluster(idVideo) {
      if (!this.puedeEscribir) return;
      if (!confirm("¿Eliminar este video?")) return;

      try {
        await materialService.eliminarVideoClusterResumen(idVideo);

        const videos = await materialService.getVideosClusterResumen(
          this.tokenActual,
          this.clusterFotoActual.id
        );
        this.videosClusterActuales = Array.isArray(videos) ? videos : [];

        // Actualizar contador en la tarjeta
        this.actualizarContadorVideosCluster(this.clusterFotoActual.id, this.videosClusterActuales.length);
      } catch (e) {
        console.error("Error al eliminar video del cluster:", e);
        alert("Error al eliminar el video");
      }
    },

    // ======================================================================
    // EXPORTAR A EXCEL
    // ======================================================================

    exportarExcelResultados() {
      if (!this.resultadosFiltrados || this.resultadosFiltrados.length === 0) {
        alert("No hay datos para exportar");
        return;
      }

      // Preparar datos para exportar
      const datos = this.resultadosFiltrados.map((r, index) => ({
        'N°': index + 1,
        'Cliente': r.cliente || '',
        'Archivo': r.archivo || '',
        'Cluster': r.cluster || '',
        'ID': r.detalleId || '',
        'Familia': r.familia || '',
        'Fabricante': r.fabricante || '',
        'Marca': r.brandName || '',
        'Part Number': r.partNumber || '',
        'Part Name': r.partName || '',
        'Modelo': r.modelo || '',
        'Condición': r.condicion || '',
        'Detalles': r.detalles || '',
        'Cantidad Inicial': r.cantidad || 0,
        'Valor Unitario Sugerido USD': r.valorSugerido || 0,
        'Valor Total Sugerido USD': r.valorTotalSugerido || 0,
        'Cantidad Disponible': r.cantidadDisponible || 0,
        'Fotos': r.cantidadFotos || 0,
        'Videos': r.cantidadVideos || 0
      }));

      // Crear worksheet
      const ws = XLSX.utils.json_to_sheet(datos);

      // Ajustar ancho de columnas
      const columnWidths = [
        { wch: 5 },  // N°
        { wch: 20 }, // Cliente
        { wch: 25 }, // Archivo
        { wch: 10 }, // Cluster
        { wch: 8 },  // ID
        { wch: 15 }, // Familia
        { wch: 15 }, // Fabricante
        { wch: 15 }, // Marca
        { wch: 20 }, // Part Number
        { wch: 30 }, // Part Name
        { wch: 15 }, // Modelo
        { wch: 15 }, // Condición
        { wch: 40 }, // Detalles
        { wch: 15 }, // Cantidad Inicial
        { wch: 25 }, // Valor Unitario Sugerido USD
        { wch: 25 }, // Valor Total Sugerido USD
        { wch: 18 }, // Cantidad Disponible
        { wch: 8 },  // Fotos
        { wch: 8 }   // Videos
      ];
      ws['!cols'] = columnWidths;

      // Crear workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Resultados Búsqueda');

      // Generar nombre de archivo
      const nombreArchivo = `Busqueda_${this.textoBusqueda}_${new Date().toISOString().split('T')[0]}.xlsx`;

      // Descargar archivo
      XLSX.writeFile(wb, nombreArchivo);
    },

    exportarExcelClusters() {
      if (!this.resumenClusters || this.resumenClusters.length === 0) {
        alert("No hay datos para exportar");
        return;
      }

      // Preparar datos para exportar
      const datos = this.resumenClusters.map((c, index) => ({
        'N°': index + 1,
        'ID': c.id,
        'Nombre Cluster': c.nombreCluster || '',
        'Tipo Cluster': c.criterio || '',
        'Fecha Carga': this.formatDate(c.fechaCreacion),
        'Ítems': c.cantidadItems || 0,
        'ID Ficha': c.idFicha || 'Sin Ficha',
        'Fotos': c.cantidadFotos || 0,
        'Videos': c.cantidadVideos || 0,
        'Categoria': c.categoria || '',
        'Fabricante': c.fabricante || '',
        'Modelo': c.modelo || '',
        'Condicion de Uso': (this.opcionesCondicionResumen.find(op => op.value === Number(c.idCondicion)) || {}).label || '',
      }));

      // Crear worksheet
      const ws = XLSX.utils.json_to_sheet(datos);

      // Ajustar ancho de columnas
      const columnWidths = [
        { wch: 5 },  // N°
        { wch: 8 },  // ID
        { wch: 25 }, // Nombre Cluster
        { wch: 25 }, // Tipo Cluster
        { wch: 15 }, // Fecha Carga
        { wch: 10 }, // Ítems
        { wch: 12 }, // ID Ficha
        { wch: 8 },  // Fotos
        { wch: 8 },  // Videos
        { wch: 25 }, // Categoria
        { wch: 20 }, // Fabricante
        { wch: 20 }, // Modelo
        { wch: 20 }, // Condicion de Uso
      ];
      ws['!cols'] = columnWidths;

      // Crear workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Resumen Clusters');

      // Generar nombre de archivo
      const nombreArchivo = this.archivoSeleccionado
        ? `${this.archivoSeleccionado.nombreXLSX}_Clusters_${new Date().toISOString().split('T')[0]}.xlsx`
        : `Resumen_Clusters_${new Date().toISOString().split('T')[0]}.xlsx`;

      // Descargar archivo
      XLSX.writeFile(wb, nombreArchivo);
    },

    // ======================================================================
    // PERSISTENCIA DE ESTADO
    // ======================================================================

    guardarEstado() {
      const estado = {
        empresaSeleccionada: this.empresaSeleccionada,
        tokenActual: this.tokenActual,
        archivoSeleccionado: this.archivoSeleccionado,
        ordenColumna: this.ordenColumna,
        ordenDireccion: this.ordenDireccion,
        ordenColumnaResultados: this.ordenColumnaResultados,
        ordenDireccionResultados: this.ordenDireccionResultados
      };
      sessionStorage.setItem('lecturaVentasEstado', JSON.stringify(estado));
    },

    async restaurarEstado() {
      const estadoGuardado = sessionStorage.getItem('lecturaVentasEstado');

      if (!estadoGuardado) {
        if (this.empresaSeleccionada) await this.onEmpresaSeleccionada();
        return;
      }

      try {
        const estado = JSON.parse(estadoGuardado);

        if (estado.empresaSeleccionada) {
          this.empresaSeleccionada = estado.empresaSeleccionada;

          // Cargar archivos de la empresa
          await this.onEmpresaSeleccionada();

          // Restaurar archivo seleccionado
          if (estado.archivoSeleccionado && estado.tokenActual) {
            // Buscar el archivo en los filtrados
            const archivoEncontrado = this.archivosFiltrados.find(
              a => a.token === estado.tokenActual
            );

            if (archivoEncontrado) {
              this.archivoSeleccionado = archivoEncontrado;
              this.tokenActual = estado.tokenActual;

              // Cargar clusters
              await this.cargarClustersResumen();
            }
          }
        }

        // Restaurar ordenamiento
        if (estado.ordenColumna !== undefined) this.ordenColumna = estado.ordenColumna;
        if (estado.ordenDireccion !== undefined) this.ordenDireccion = estado.ordenDireccion;
        if (estado.ordenColumnaResultados !== undefined) this.ordenColumnaResultados = estado.ordenColumnaResultados;
        if (estado.ordenDireccionResultados !== undefined) this.ordenDireccionResultados = estado.ordenDireccionResultados;

        // Limpiar estado guardado después de restaurar
        sessionStorage.removeItem('lecturaVentasEstado');
      } catch (e) {
        console.error("Error restaurando estado:", e);
        sessionStorage.removeItem('lecturaVentasEstado');
      }
    },

    // ======================================================================
    // PUBLICACIÓN
    // ======================================================================

    getPublicacionVariant(estado) {
      if (!estado || estado === 'N') return 'danger';
      if (estado === 'S') return 'warning';
      if (estado === 'P') return 'success';
      if (estado === 'D') return 'info';
      return 'secondary';
    },

    getPublicacionLabel(estado) {
      if (!estado || estado === 'N') return this.$t('pub_no_publicado');
      if (estado === 'S') return this.$t('pub_solicitado');
      if (estado === 'P') return this.$t('pub_publicado');
      if (estado === 'D') return this.$t('pub_despublicacion_solicitada');
      return '';
    },

    async solicitarPublicacion(item) {
      if (!this.puedeEscribir) return;
      if (!item.idFicha) return;
      // Permite (re)publicar desde 'N'/vacío o desde 'P' (republicar); bloqueado solo en estados transitorios
      if (item.estadoPublicacion === 'S' || item.estadoPublicacion === 'D') return;

      const confirmado = await this.$bvModal.msgBoxConfirm(this.$t('pub_confirmar_solicitar'), {
        title: this.$t('confirmar'),
        okVariant: 'warning',
        okTitle: this.$t('si_confirmar'),
        cancelTitle: this.$t('cancelar'),
        centered: true,
      });
      if (!confirmado) return;
      try {
        await fichaService.actualizarPublicacion(item.idFicha, 'S');
        item.estadoPublicacion = 'S';
      } catch (e) {
        this.$bvToast.toast(e.message || 'Error al actualizar publicación', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      }
    },

    async solicitarDespublicacion(item) {
      if (!this.puedeEscribir) return;
      if (!item.idFicha) return;
      if (item.estadoPublicacion !== 'P') return;

      const confirmado = await this.$bvModal.msgBoxConfirm(this.$t('pub_confirmar_despublicar'), {
        title: this.$t('confirmar'),
        okVariant: 'danger',
        okTitle: this.$t('si_confirmar'),
        cancelTitle: this.$t('cancelar'),
        centered: true,
      });
      if (!confirmado) return;
      try {
        await fichaService.actualizarPublicacion(item.idFicha, 'D');
        item.estadoPublicacion = 'D';
      } catch (e) {
        this.$bvToast.toast(e.message || 'Error al actualizar publicación', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      }
    },

    async abrirEnPortal(item) {
      window.open(`${this.ecommerceUrl}/product/${item.mongoSlug}`, '_blank');
    }

  }
};
</script>

<style>
.modal-ficha-wide {
  max-width: 90% !important;
  width: 90% !important;
}
</style>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}

.divisor-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.divisor-sync {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.divisor-sync-refresh {
  padding: 0;
  line-height: 1;
  color: white !important;
  font-size: 20px;
  opacity: 0.85;
}

.divisor-sync-refresh:hover {
  opacity: 1;
}

.clusters-count-badge {
  background: linear-gradient(135deg, #6172e9 0%, #4a5bc7 100%);
  color: white;
  padding: 4px 11px;
  border-radius: 20px;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(97, 114, 233, 0.3);
}

.clusters-count-badge strong {
  font-size: 12px;
  margin-right: 4px;
}

.filtro-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
  color: #444;
  display: block;
}

/* Badge ecommerce: Bootstrap no define esta clase */
.badge-ecommerce {
  background-color: #007bff;
  color: white;
}

/* Badges grandes solo para la sección de multimedia (fotos/videos) */
.multimedia-badges .badge-success {
  background-color: #28a745;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
}

.multimedia-badges .badge-danger {
  background-color: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
}

.multimedia-badges {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* Estilos para videos */
.video-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #e0e0e0;
}

.video-preview {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 6px;
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.video-preview-small {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding-bottom: 225px;
  height: 0;
  overflow: hidden;
  border-radius: 6px;
  border: 2px solid #28a745;
}

.video-iframe-small {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

.video-actions {
  padding-top: 8px;
}

::v-deep .nav-tabs .nav-link.active,
::v-deep .nav-tabs .nav-item.show .nav-link {
  background-color: #4e4e4e !important;
  color: #ffffff !important;
  border-color: #606060 !important;
  border-radius: 7px 7px 0px 0px;
}

.text-muted {
  margin-right: 14px !important;
}

::v-deep .nav-tabs .nav-link.active {
  background-color: #5f5f5f !important;
  color: #ffffff !important;
  border-color: #5f5f5f !important;
}

button.btn.mt-3.btn-success {
  margin-top: 0px !important;
  margin-left: 20px;
}

.tabla-clusters-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.table-responsive-custom {
  overflow-x: auto;
  position: relative;
  scrollbar-width: none; /* Firefox: oculta la barra, se navega con los botones del footer */
  -ms-overflow-style: none; /* IE/Edge */
}

.table-responsive-custom::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Edge */
}

.row-destacada {
  animation: parpadeo-destacado 1.5s ease-in-out 3;
  background-color: #fff3cd !important;
}

.fila-modificada {
  background-color: #fff8e1 !important;
}

@keyframes parpadeo-destacado {
  0%, 100% { background-color: #fff3cd; }
  50% { background-color: #ffe69c; }
}

.tabla-clusters-scroll thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 10;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
  font-size: 11px;
  /* Letra más chica en encabezados */
}

.thead-light th {
  font-size: 11px;
}

.tabla-clusters-scroll tbody td {
  font-size: 12px;
  /* Letra más chica en celdas */
  padding: 8px;
  /* Reducir padding para compactar */
}

.tabla-clusters-scroll .btn-sm {
  font-size: 11px;
  /* Botones más chicos */
  padding: 4px 8px;
}

.tabla-clusters-scroll .multimedia-badges {
  font-size: 11px;
  /* Badges más chicos */
}

.tabla-clusters-scroll .multimedia-badges .badge {
  font-size: 11px;
  padding: 3px 6px;
}


.th-ordenable {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.tabla-archivos-cargados th,
.tabla-archivos-cargados td {
  font-size: 12px;
}

.tabla-archivos-cargados td .badge {
  font-size: 11px;
}

.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-ordenable:active {
  background-color: #dee2e6 !important;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.th-checkbox-label {
  display: block;
  font-size: 10px;
  font-weight: normal;
  white-space: nowrap;
  margin-top: 3px;
  cursor: pointer;
}

.btn-compact-row {
  padding: 0.2rem 0.5rem !important;
  font-size: 11px !important;
  line-height: 1.2 !important;
}

.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}

.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

</style>
